import { DownloadOutlined, MenuOutlined, SettingOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Empty, FormInstance, Input, Popover, Row, Table } from "antd/es";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { saveAs } from "file-saver";
import { Guid } from "guid-typescript";
import _ from "lodash";
import moment from "moment";
import objectPath from "object-path";
import React, { PureComponent, ReactNode } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import ReactDOM from "react-dom";
import isEqual from "react-fast-compare";
import shallowequal from "shallowequal";
import CarouselPlaceholder from "../../../../public/images/carousel-placeholder.svg";
import EmptyDataSvg from "../../../../public/images/empty-table.svg";
import FlexGridPlaceholder from "../../../../public/images/flex-grid-placeholder.svg";
import HorizontalGridPlaceholder from "../../../../public/images/horizontal-grid-placeholder.svg";
import DynamicStyleManager from "../../../shared/utilty/dynamic-style-manager";
import { KMainFunctions } from "../../../shared/utilty/main-functions";
import { getCachedNumberFormat } from "../../../shared/utilty/number-format-cache";
import { CommonProps } from "../common/common-props";
import { Image } from "../image/image";
import { DashboardState, toCamelCase } from "../kuika-cl-model-runtimes";
import { CarouselBodyCell } from "./body/carousel/carousel-body-cell";
import { CarouselBodyWrapper, CarouselBodyWrapperProps } from "./body/carousel/carousel-body-wrapper";
import { CarouselItem } from "./body/carousel/carousel-item";
import { FlexGridBodyCell } from "./body/flex-grid/flex-grid-body-cell";
import { FlexGridBodyWrapper } from "./body/flex-grid/flex-grid-body-wrapper";
import { FlexGridItem } from "./body/flex-grid/flex-grid-item";
import { GalleryBodyCell } from "./body/gallery/gallery-body-cell";
import { GalleryBodyWrapper, GalleryBodyWrapperProps } from "./body/gallery/gallery-body-wrapper";
import { GalleryItem, GalleryItemProps } from "./body/gallery/gallery-item";
import { GoogleMapsBodyCell } from "./body/google-maps/google-maps-body-cell";
import { GoogleMapsBodyWrapper, GoogleMapsBodyWrapperProps } from "./body/google-maps/google-maps-body-wrapper";
import { GoogleMapsItem, ICoords, MarkerDetailPosition, MarkerDetailView } from "./body/google-maps/google-maps-item";
import { TableBodyCell } from "./body/table/table-body-cell";
import { TableBodyWrapper } from "./body/table/table-body-wrapper";
import { TableColumnProps } from "./body/table/table-column";
import CustomFilterDropdown from "./custom-table-filter-dropdown";
import { TableData, TableDataProps } from "./data/table-data";
import { TableHeaderCell } from "./header/table-header-cell";
import { TableHeaderRow } from "./header/table-header-row";
import { RefreshDelegate } from "./refresh-delegate";
import "./table.scss";
import { CarouselViewWrapper } from "./wrapper/carousel-view-wrapper";
import { FlexGridViewWrapper } from "./wrapper/flex-grid-view-wrapper";
import { GalleryViewWrapper } from "./wrapper/gallery-view-wrapper";
import { GoogleMapsViewWrapper } from "./wrapper/google-maps-view-wrapper";
import { TableViewWrapper } from "./wrapper/table-view-wrapper";

export type ViewMode = "table" | "gallery" | "carousel" | "flex-grid" | "google-maps";

declare let window: any;

export enum StringFilterTypes {
  Contains = "contains",
  DoesNotContain = "does_not_contain",
  Equals = "equals",
  DoesNotEqual = "does_not_equal",
  BeginsWith = "begins_with",
  EndsWith = "ends_with",
  Blank = "blank",
  NotBlank = "not_blank"
}

export enum NumberFilterTypes {
  Equals = "number_equals",
  DoesNotEqual = "number_does_not_equal",
  GreaterThan = "greater_than",
  LessThan = "less_than",
  GreaterThanOrEqual = "greater_than_or_equal",
  LessThanOrEqual = "less_than_or_equal",
  Between = "number_between",
  Blank = "number_blank",
  NotBlank = "number_not_blank"
}

export enum DateFilterTypes {
  Equals = "date_equals",
  DoesNotEqual = "date_does_not_equal",
  After = "after",
  Before = "before",
  Between = "date_between",
  Blank = "date_blank",
  NotBlank = "date_not_blank"
}

export enum BooleanFilterTypes {
  Equals = "boolean_equals",
  DoesNotEqual = "boolean_does_not_equal",
  Blank = "boolean_blank",
  NotBlank = "boolean_not_blank"
}

export enum ValueType {
  String = "string",
  Number = "number",
  Date = "date",
  Boolean = "boolean"
}

export enum FooterOptions {
  None = "none",
  Average = "average",
  Sum = "sum",
  Min = "min",
  Max = "max",
  Count = "count"
}

export interface ITableProps {
  children?: any;
  nodatafoundmessage?: string;
  rowBgColor?: (rowData: any, rowIndex?: number) => string;
  rowFontColor?: (rowData: any, rowIndex?: number) => string;
  dataSource?: any[];
  loading?: boolean;
  size?: SizeType;
  sorter?: boolean;
  pagination?: boolean;
  showHeader?: boolean;
  style?: any;
  mode?: ViewMode;
  striped?: boolean;
  stripedColor?: string;
  hideHeaderOnMobileResolution?: boolean;
  // Maps Props
  onChange?: (value?: any | undefined) => void;
  value?: any;
  latitude?: string;
  longitude?: string;
  zoom?: number; /// zoom /// 1-> World /// 5-> Landmass/continent 10 -> City /// 15-> Streets /// 20-> Buildings şeklinde tanımlanırsa veya açıklama yazılırsa low code için daha anlamlı olabilir.
  isMarkerPicker?: boolean;
  isPicker?: boolean;
  hasSearchBox?: boolean;
  disableDoubleClickZoom?: boolean;
  fullScreenControlV1?: "show" | "hide" | "user select" | boolean;
  streetViewControlV1?: "show" | "hide" | "user select" | boolean;
  scaleControlV1?: "show" | "hide" | "user select" | boolean;
  zoomControlV1?: "show" | "hide" | "user select" | boolean;
  panControl?: boolean;
  rotateControlV1?: "show" | "hide" | "user select" | boolean;
  cameraControl?: "show" | "hide" | "user select" | boolean;
  mapTypeControl?: boolean;
  autoCenter?: boolean;
  designClicked?: boolean;
  onClickDesign?: (value: boolean) => void;
  dataLatField?: string;
  dataLngField?: string;
  markerDetailView?: MarkerDetailView;
  markerDetailPosition?: MarkerDetailPosition;
  markerDetailHeight?: number;
  markerDetailWidth?: number;
  circleRadius?: number;
  groupPickerIcon?: string;
  groupPickerColor?: string;
  selectedLocationIcon?: string;
  selectedLocationColor?: string;
  currentLocationIcon?: string;
  currentLocationColor?: string;
  mapType?: "roadmap" | "terrain" | "satellite" | "hybrid";
  hideTrafficLayer?: boolean;
  hideTransitLayer?: boolean;
  enableLocationTracking?: boolean;
  waypoints?: any[];
  waypointLatField?: string;
  waypointLngField?: string;
  // Carousel Props
  setCurrentSlideNumber?: (val: number) => void;
  startingIndex?: number;
  hideTableOnEmpty?: boolean;
  rowHoverFontColor?: string;
  transformedOnMobileResolution?: boolean;
  rowHoverBgColor?: string;
  kuikacomponentname?: string;
  onRowEditFinished?: () => void;
  onInsertRowFinished?: () => void;
  form?: FormInstance<any>;
  insertRowActive?: boolean;
  insertRowPosition?: "top" | "bottom";
  noDataFoundImage?: string;
  filtering?: boolean;
  searchable?: boolean;
  tableWidthMode?: "fit" | "horizontal scroll" | "scroll";
  columnChooser?: boolean;
  editableAlwaysActive?: boolean;
  onConfigChange?: () => void;
  multiSelect?: boolean;
  selectedValues?: any;
  onSelectedValuesChange?: () => void;
  fixedHeader?: boolean;
  pageSize?: number;
  showSizeChanger?: boolean;
  options?: any[];
  onRowDoubleClick?: () => void;
  showNoDataFound?: boolean;
  resizableColumns?: boolean;
  selectedRowColor?: string;
  editable?: boolean;
  globalSearch?: boolean;
  export?: boolean;
  datavaluefield?: string;
  multiSelectScope?: "page" | "all";
  arrowColor?: string;
  shouldSearchOnChange?: boolean;
  searchDelay?: number;
  rowKey?: string;
  paginationUnselectedTextColor?: string;
  paginationSelectedTextColor?: string;
  showPageIndicator?: boolean;
  exportButtonBgColor?: string;
  exportFileName?: string;
  showRowNumbers?: boolean;
}

export interface IColumnGroup {
  title: string;
  children: TableColumnProps[];
  style?: React.CSSProperties;
  groupBackgroundColor?: string;
  groupFontColor?: string;
  groupFontSize?: number;
  groupFontWeight?: string;
}

export interface ITableState {
  columnTitles?: string[];
  selectedRowKeys: any;
  selectedRowKeysString: any;
  columns?: TableColumnProps & CommonProps[];
  columnGroups?: IColumnGroup[];
  headerStyle?: any;
  rowStyle?: any;
  footerStyle?: any;
  headerRenderer?: any;
  rowRenderer?: any;
  selectedIndexGuid: string;
  selectedColumnIndexGuid: string;
  selectedRowDataGuid: string;
  // Maps States:
  maps?: any;
  map?: any;
  isDataMarkerSelected: boolean;
  value?: any;
  uniqueKey?: Guid;
  activeEditableRowIndex?: number;
  randomGuid?: string;
  searchText: string;
  columnSearchTexts?: { [key: string]: string };
  carouselStartingIndex?: number;
  hiddenColumnList?: any[];
  columnOrder?: any[];
  filteringOptions?: any;
  sorterOptions?: any;
  pageSize?: any;
  resizingColumnIndex?: number;
  columnWidths?: any;
  current: number;
  hideHeaderOnMobileResolution?: boolean;
  excludedFromExportList?: any[];
  actualRowKey?: string;
}

let isEventListenerAdded = false;

export abstract class BaseTable<P, S> extends PureComponent<ITableProps & P & CommonProps, ITableState & S> {
  private static readonly DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

  private uniqueKey: Guid;

  private style: DynamicStyleManager;

  private randomGuid: string;

  private cachedColumnWidths = new Map<string, number>();

  private syncWidthsTimerId: ReturnType<typeof setTimeout> | undefined;

  timeOutId = undefined;

  lastSelectedLat: any;

  lastSelectedLng: any;

  resizingColumnIndexRef = React.createRef<number>();

  startX: number | undefined;

  initialWidth: number | undefined;

  nextFocusTarget: { columnIndex: number; rowIndex: string } | null = null;

  tableElement: HTMLElement | null = null;

  constructor(props: ITableProps & P) {
    super(props);
    const cleanedValues = this.props.selectedValues?.replace(/^,|,$/g, "");
    this.uniqueKey = Guid.create();
    this.style = new DynamicStyleManager(`ktable_${this.uniqueKey}`);
    this.randomGuid = Guid.create().toString();
    this.state = {
      uniqueKey: this.uniqueKey,
      columns: [],
      selectedRowKeys: cleanedValues ? cleanedValues.split(",").map((v) => v.toLowerCase()) : [],
      selectedRowKeysString: cleanedValues || "",
      selectedIndexGuid: Guid.create().toString(),
      selectedColumnIndexGuid: Guid.create().toString(),
      selectedRowDataGuid: Guid.create().toString(),
      activeEditableRowIndex: window.kuika.isDesignTime ? 0 : -1,
      searchText: "",
      columnSearchTexts: {},
      carouselStartingIndex: 0,
      hiddenColumnList: [],
      columnOrder: [],
      filteringOptions: {},
      sorterOptions: {},
      pageSize: this.props.pageSize && this.props.pageSize >= 1 ? this.props.pageSize : 10,
      resizingColumnIndex: null,
      columnWidths: undefined,
      current: 1,
      excludedFromExportList: [],
      actualRowKey: BaseTable.resolveActualRowKey(this.props.dataSource, this.props.rowKey)
    } as any;
  }

  public static defaultProps = {
    mode: "table",
    designClicked: true
  };

  static withColumnProps(props: any, value: any, rowData: any, rowIndex: number): any {
    props.value = value;
    props.rowData = rowData;
    props.rowIndex = rowIndex;
    return props;
  }

  static resolveActualRowKey(dataSource: any[], rowKey: string): string {
    if (!dataSource || dataSource.length === 0 || !rowKey || typeof dataSource === "string") {
      return rowKey || "id";
    }

    const sampleRecord = dataSource?.find((record) => record && typeof record === "object");
    if (!sampleRecord) {
      return rowKey || "id";
    }

    if (sampleRecord.hasOwnProperty(rowKey)) {
      return rowKey;
    }

    const actualKey = Object.keys(sampleRecord).find((key) => key.toLowerCase() === rowKey.toLowerCase());

    return actualKey || rowKey;
  }

  static findRowByKey(dataSource: any[], searchValue: string, keyFieldProp?: string): any {
    if (!dataSource) {
      return undefined;
    }

    const rowKeyField = BaseTable.resolveActualRowKey(dataSource, keyFieldProp || "id");
    let result = dataSource.find((item) => item[rowKeyField]?.toString() === searchValue);

    if (!result && rowKeyField !== "id") {
      result = dataSource.find((item) => item.id?.toString() === searchValue);
    }

    return result;
  }

  static getDerivedStateFromProps(nextProps: ITableProps & CommonProps, prevState: ITableState) {
    const result: Partial<ITableState> = {
      selectedIndexGuid: prevState.selectedIndexGuid,
      selectedColumnIndexGuid: prevState.selectedColumnIndexGuid,
      selectedRowDataGuid: prevState.selectedRowDataGuid,
      maps: prevState.maps,
      map: prevState.map,
      isDataMarkerSelected: prevState.isDataMarkerSelected,
      activeEditableRowIndex: prevState.activeEditableRowIndex,
      columnSearchTexts: prevState.columnSearchTexts,
      searchText: prevState.searchText,
      hiddenColumnList: prevState.hiddenColumnList,
      filteringOptions: prevState.filteringOptions,
      sorterOptions: prevState.sorterOptions,
      selectedRowKeys: prevState.selectedRowKeys,
      selectedRowKeysString: prevState.selectedRowKeysString,
      columnWidths: prevState.columnWidths,
      actualRowKey: BaseTable.resolveActualRowKey(nextProps.dataSource, nextProps.rowKey)
    };
    if (nextProps.children) {
      result.columns = [] as CommonProps[];
      if (nextProps.mode === "carousel") {
        result.rowStyle = nextProps.style;
        BaseTable.setCarouselItem(result, nextProps.children);
      } else if (nextProps.mode === "gallery") {
        result.rowStyle = nextProps.style;
        BaseTable.setGalleryItem(result, nextProps.children);
      } else if (nextProps.mode === "flex-grid") {
        result.rowStyle = nextProps.style;
        BaseTable.setFlexGridItem(result, nextProps.children);
      } else if (nextProps.mode === "google-maps") {
        if (nextProps.value !== undefined) {
          result.value = nextProps.value;
        }
        React.Children.forEach(nextProps.children, (child, childIndex) => {
          switch (childIndex) {
            // GoogleMapsMarker
            case 0:
              BaseTable.setGoogleMapsItem(result, child, nextProps);
              break;
          }
        });
      } else {
        React.Children.forEach(nextProps.children, (child, childIndex) => {
          const isHeader = nextProps?.children?.length > 1 && childIndex === 0;
          const isRow =
            (nextProps?.children?.length > 1 && childIndex === 1) || typeof nextProps?.children === "object";
          switch (childIndex) {
            // Header
            case 0:
              if (
                child.type.name == "TableHeader" ||
                (child.props.kuikacomponentname && child.props.kuikacomponentname === "TableHeader") ||
                child.type.name == "ReportTableHeader" ||
                child.type.name == "StaticTableHeader" ||
                (child.props.kuikacomponentname && child.props.kuikacomponentname === "ReportTableHeader") ||
                isHeader
              ) {
                BaseTable.setHeader(result, child, prevState, nextProps);
              } else if (
                child.type.name == "TableRow" ||
                (child.props.kuikacomponentname && child.props.kuikacomponentname === "TableRow") ||
                child.type.name == "ReportTableRow" ||
                child.type.name == "StaticTableRow" ||
                (child.props.kuikacomponentname && child.props.kuikacomponentname === "ReportTableRow") ||
                isRow
              ) {
                BaseTable.setRow(
                  result,
                  child,
                  nextProps,
                  nextProps.sorter,
                  nextProps.filtering,
                  nextProps.dataSource,
                  nextProps.style
                );
                result.headerRenderer = (_props: any) => {
                  return React.createElement("div");
                };
              }
              break;
            // Row
            default:
              BaseTable.setRow(
                result,
                child,
                nextProps,
                nextProps.sorter,
                nextProps.filtering,
                nextProps.dataSource,
                nextProps.style
              );
              break;
          }
        });
      }

      if (prevState.columnOrder?.length > 0) {
        const orderedColumns = prevState.columnOrder
          .map((orderId) => result?.columns?.find((col) => col.id === orderId))
          .filter(Boolean);

        const remainingColumns = result?.columns?.filter((col) => !prevState.columnOrder.includes(col.id));

        if (remainingColumns?.length > 0) {
          result.columns = [...orderedColumns, ...remainingColumns];
        } else {
          result.columns = orderedColumns;
        }

        if (result.columnGroups && result.columnGroups.length > 0) {
          result.columnGroups = result.columnGroups.map((group) => {
            const orderedChildren = prevState.columnOrder
              .map((orderId) => group.children.find((child) => child.id === orderId))
              .filter(Boolean);

            const remainingChildren = group.children.filter((child) => !prevState.columnOrder.includes(child.id));

            if (remainingChildren.length > 0) {
              return {
                ...group,
                children: [...orderedChildren, ...remainingChildren]
              };
            }
            return { ...group, children: orderedChildren };
          });
        }
      }

      return result;
    }
  }

  static setHeader = (result: Partial<ITableState>, child: any, prevState: any, nextProps: any) => {
    let headerStyle: any = {};

    if (child.props.style) {
      headerStyle = child.props.style;
    }

    if (child.props.writingMode && child.props.writingMode === "vertical") {
      headerStyle.writingMode = "vertical-lr";
    }

    if (
      child.props.textDirection &&
      (child.props.textDirection === "Rotate Up" || child.props.textDirection === "Rotate Down")
    ) {
      headerStyle.writingMode = "vertical-lr";
      if (child.props.textDirection === "Rotate Up") {
        headerStyle.transform = "rotate(180deg)";
      }
    }

    result.headerStyle = headerStyle;
    result.headerRenderer = (props: any) => {
      let _props = { ...props };

      _props.wrapperClassname = `.ktable_${prevState.uniqueKey.toString().substring(0, 8)}`;
      _props.transformedOnMobileResolution = nextProps.transformedOnMobileResolution;

      return React.cloneElement(child, _props);
    };

    if (child.props.columnTitles) {
      result.columnTitles = child.props.columnTitles.split(";");
    }
  };

  static setRow = (
    result: Partial<ITableState>,
    child: any,
    _nextProps: ITableProps,
    sorter?: boolean,
    filtering?: boolean,
    datasource?: any,
    tableStyle?: any
  ) => {
    result.rowStyle = child.props.style;
    result.rowRenderer = (props: any) => {
      return React.cloneElement(child, props);
    };

    if (!result.columnGroups) {
      result.columnGroups = [];
    }
    if (!result.columns) {
      result.columns = [];
    }

    React.Children.forEach(child.props.children, (grandChild, grandChildIndex) => {
      const columnProps: TableColumnProps & CommonProps = _.clone(grandChild.props);
      const props = {};
      Object.keys(grandChild.props).forEach((key) => {
        if (key !== "children" || typeof grandChild.props[key] === "string") {
          props[key] = grandChild.props[key];
        }
      });

      columnProps.render = (value: any, rowData: any, rowIndex: number) => {
        let children = grandChild?.props?.children;
        if (grandChild?.props?.children?.length === 2 && grandChild.props.isEditableColumn) {
          children = [];
          if (grandChild.props.isEditableColumn) {
            if (_nextProps.editableAlwaysActive) {
              children.push(grandChild.props.children[1]);
            } else if (result.activeEditableRowIndex === rowIndex) {
              children.push(grandChild.props.children[1]);
            } else {
              children.push(grandChild.props.children[0]);
            }
          }
        }
        return (
          <>{React.cloneElement(grandChild, BaseTable.withColumnProps(props, value, rowData, rowIndex), children)}</>
        );
      };

      delete columnProps.children;
      if (
        columnProps &&
        result &&
        result.columnTitles &&
        result.columnTitles.length > grandChildIndex &&
        result.columnTitles[grandChildIndex]?.length > 0
      ) {
        columnProps.title = result.columnTitles[grandChildIndex];
      }

      let value =
        grandChild.props?.children?.props?.value ??
        grandChild.props?.children?.props?.children?.props?.value ??
        grandChild.props?.children?.props?.children?.props?.children?.props?.value;
      if (grandChild.props?.children?.props?.className === "kFormItem" && !value?.toString().includes("[datafield:")) {
        value = undefined;
      }
      if (value === undefined && grandChild.props?.children && grandChild.props?.children.length > 0) {
        value =
          grandChild.props?.children[0]?.props?.value ?? grandChild.props?.children[0]?.props?.children?.props?.value;
      }
      const dataBindedChilds = [];

      const processChildren = (children) => {
        if (Array.isArray(children)) {
          children.forEach((child) => {
            if (child.props?.children) {
              processChildren(child.props.children);
            }
            Object.keys(child.props).forEach((key) => {
              if (
                child.props[key]?.toString().includes("[datafield:") &&
                key !== "visExField1" &&
                key !== "visExField2" &&
                key !== "tooltip"
              ) {
                dataBindedChilds.push(child.props[key]);
              }
            });
          });
        } else if (children) {
          if (children.props?.children) {
            processChildren(children.props.children);
          }
          if (children.props) {
            Object.keys(children.props).forEach((key) => {
              if (
                children.props[key]?.toString().includes("[datafield:") &&
                key !== "visExField1" &&
                key !== "visExField2" &&
                key !== "tooltip"
              ) {
                dataBindedChilds.push(children.props[key]);
              }
            });
          }
        }
      };

      if (grandChild.props?.children?.props?.className !== "kFormItem") {
        processChildren(grandChild.props?.children);
      }

      if (value === undefined && grandChild.props?.children?.props?.className !== "kFormItem") {
        processChildren(grandChild.props?.children?.props?.children);
      } else if (value === undefined && grandChild.props?.children?.props?.children?.props.className !== "kFormItem") {
        processChildren(grandChild.props?.children?.props?.children?.props.children);
      }

      if (
        dataBindedChilds.length === 1 ||
        (dataBindedChilds.length > 1 &&
          dataBindedChilds.every((dataBindedChild) => dataBindedChild === dataBindedChilds[0]))
      ) {
        value = dataBindedChilds[0];
      } else if (
        dataBindedChilds.length > 1 &&
        !dataBindedChilds.every((dataBindedChild) => dataBindedChild === dataBindedChilds[0])
      ) {
        value = undefined;
      }

      if (
        dataBindedChilds.length > 1 &&
        !dataBindedChilds.every((dataBindedChild) => dataBindedChild === dataBindedChilds[0]) &&
        columnProps.defaultDataField
      ) {
        value = columnProps.defaultDataField?.toLowerCase();
      }
      if (value && !value?.toString().includes("[datafield:") && !columnProps.defaultDataField) {
        value = undefined;
      }
      if (grandChild.props?.children?.props?.children?.props?.checked) {
        value = grandChild.props?.children?.props?.children?.props?.checked;
      }

      if (
        !value &&
        grandChild.props?.children &&
        grandChild.props?.children.length > 1 &&
        grandChild.props?.children?.some(
          (child) =>
            child?.props?.visibility === "hidden" &&
            (grandChild.props?.children?.some((child) => !child?.props?.visibility) ||
              grandChild.props?.children?.some((child) => child?.props?.visibility === "visible"))
        )
      ) {
        const visibleColumnValue =
          grandChild.props?.children?.find((child) => !child?.props?.visibility)?.props?.value ||
          grandChild.props?.children?.find((child) => child?.props?.visibility === "visible")?.props?.value;
        value = visibleColumnValue;
      }
      if (value || window.kuika.isDesignTime) {
        value = value?.toString()?.replace("[datafield:", "")?.replace("]", "");
        let dataType = ValueType.String;

        function getDataTypeRecursively(datasource, value) {
          if (!datasource || datasource.length === 0) {
            return null;
          }

          if (datasource[0] !== null && datasource[0] !== undefined) {
            if (datasource[0][value] !== undefined && datasource[0][value] !== null) {
              return BaseTable.getValueType(datasource[0][value]);
            }

            const keys = Object.keys(datasource[0]);
            const matchingKey = keys.find((key) => key?.toLowerCase() === value?.toLowerCase());

            if (matchingKey && datasource[0][matchingKey] !== undefined && datasource[0][matchingKey] !== null) {
              return BaseTable.getValueType(datasource[0][matchingKey]);
            }
          }

          return getDataTypeRecursively(datasource?.slice(1), value);
        }
        dataType = getDataTypeRecursively(datasource?.slice(0, 10), value);

        if (sorter && columnProps?.hideSorting !== true) {
          columnProps.sorter = (a, b) => BaseTable.compare(value, a, b, _nextProps.rowKey);
        }
        if (filtering && columnProps?.hideFiltering !== true) {
          let initialFilters: any = {};

          if (result.filteringOptions) {
            Object.values(result.filteringOptions).forEach((filters: any) => {
              if (filters && filters.length > 0 && filters[0].columnId === columnProps.id) {
                initialFilters = filters[0];
              }
            });
          }

          columnProps.filteredValue =
            initialFilters.value ||
            initialFilters.value === false ||
            initialFilters.value === 0 ||
            initialFilters.type === "blank" ||
            initialFilters.type === "not_blank" ||
            initialFilters.type === "number_blank" ||
            initialFilters.type === "number_not_blank" ||
            initialFilters.type === "date_blank" ||
            initialFilters.type === "date_not_blank" ||
            initialFilters.type === "boolean_blank" ||
            initialFilters.type === "boolean_not_blank"
              ? [initialFilters]
              : [];

          columnProps.filterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters, visible }) =>
            filtering && (
              <CustomFilterDropdown
                selectedKeys={selectedKeys[0]}
                setSelectedKeys={(text) => setSelectedKeys([text])}
                confirm={confirm}
                clearFilters={clearFilters}
                dataType={dataType}
                visible={visible}
                initialFilters={initialFilters}
                columnId={columnProps.id}
                tableStyle={tableStyle}
                dateSearchFormat={(columnProps as any).dateSearchFormat}
              />
            );
          columnProps.onFilter = (searchValue: any, record) => {
            if (dataType === ValueType.Date) {
              searchValue = {
                ...searchValue,
                dateSearchFormat: (columnProps as any).dateSearchFormat
              };
            }
            return BaseTable.applyFilter(searchValue, record, value, dataType);
          };
        }
        (columnProps as any).dataType = dataType;
        (columnProps as any).dataValue = value;
      }

      if (columnProps.group) {
        let group = result.columnGroups?.find((g) => g.title === columnProps.group);
        if (!group) {
          group = {
            title: columnProps.group,
            children: [],
            style: {
              ...columnProps.style,
              background: columnProps.calculatedCellBgColor
            },
            groupBackgroundColor: columnProps.groupBackgroundColor,
            groupFontColor: columnProps.groupFontColor,
            groupFontSize: columnProps.groupFontSize,
            groupFontWeight: columnProps.groupFontWeight
          };
          result.columnGroups?.push(group);
        }
        columnProps.isGroup = true;
        group.children.push(columnProps);
        result.columns?.push(columnProps);
      } else {
        result.columns?.push(columnProps);
      }
    });
  };

  static applyFilter = (searchValue: any, record: any, value: any, dataType: any) => {
    const { type } = searchValue;
    const recordValue = record[value];
    const logicalOperator = searchValue?.logicalOperator;
    const secondType = searchValue?.secondType;
    const secondValue = searchValue?.secondValue;
    const secondValue2 = searchValue?.secondValue2;

    if (secondType) {
      const firstResult = BaseTable.applySingleFilter(
        {
          type,
          value: searchValue?.value,
          value2: searchValue?.value2
        },
        recordValue,
        dataType
      );

      const secondResult = BaseTable.applySingleFilter(
        {
          type: secondType,
          value: secondValue,
          value2: secondValue2
        },
        recordValue,
        dataType
      );

      return logicalOperator === "OR" ? firstResult || secondResult : firstResult && secondResult;
    }

    return BaseTable.applySingleFilter(searchValue, recordValue, dataType);
  };

  static applySingleFilter = (searchValue: any, recordValue: any, dataType: any) => {
    const { type } = searchValue;
    const valueType = BaseTable.getValueType(recordValue, dataType);

    if (valueType === ValueType.String || !valueType) {
      const normalizedRecordValue = BaseTable.normalizeTurkishString(recordValue?.toString());
      const normalizedSearchValue =
        type === "blank" || type === "number_blank" || type === "date_blank" || type === "boolean_blank"
          ? null
          : BaseTable.normalizeTurkishString(searchValue?.value?.toString());

      switch (type) {
        case StringFilterTypes.Contains:
          return normalizedRecordValue?.includes(normalizedSearchValue);
        case StringFilterTypes.DoesNotContain:
          return !normalizedRecordValue?.includes(normalizedSearchValue);
        case StringFilterTypes.Equals:
          return normalizedRecordValue === normalizedSearchValue;
        case StringFilterTypes.DoesNotEqual:
          return normalizedRecordValue !== normalizedSearchValue;
        case StringFilterTypes.BeginsWith:
          return normalizedRecordValue?.startsWith(normalizedSearchValue);
        case StringFilterTypes.EndsWith:
          return normalizedRecordValue?.endsWith(normalizedSearchValue);
        case StringFilterTypes.Blank:
          return !recordValue;
        case StringFilterTypes.NotBlank:
          return !!recordValue;
        default:
          return normalizedRecordValue?.includes(normalizedSearchValue);
      }
    } else if (valueType === ValueType.Number) {
      const recordValueNumber = Number(recordValue);

      switch (type) {
        case NumberFilterTypes.Equals:
          return recordValueNumber === Number(searchValue?.value);
        case NumberFilterTypes.DoesNotEqual:
          return recordValueNumber !== Number(searchValue?.value);
        case NumberFilterTypes.GreaterThan:
          return recordValueNumber > Number(searchValue?.value);
        case NumberFilterTypes.LessThan:
          return recordValueNumber < Number(searchValue?.value);
        case NumberFilterTypes.GreaterThanOrEqual:
          return recordValueNumber >= Number(searchValue?.value);
        case NumberFilterTypes.LessThanOrEqual:
          return recordValueNumber <= Number(searchValue?.value);
        case NumberFilterTypes.Between:
          if (searchValue?.value !== undefined && searchValue?.value2 !== undefined) {
            const min = Number(searchValue.value);
            const max = Number(searchValue.value2);
            return !isNaN(min) && !isNaN(max) && recordValueNumber >= min && recordValueNumber <= max;
          }
          return recordValueNumber === Number(searchValue?.value);
        case NumberFilterTypes.Blank:
          return !recordValue && recordValue !== 0;
        case NumberFilterTypes.NotBlank:
          return !!recordValue || recordValue === 0;
        default:
          return recordValueNumber === Number(searchValue?.value);
      }
    } else if (valueType === ValueType.Date) {
      if (!recordValue || recordValue === "") {
        if (type === DateFilterTypes.Blank) return true;
        if (type === DateFilterTypes.NotBlank) return false;
        if (type === DateFilterTypes.DoesNotEqual) return true;
        return false;
      }

      const recordValueDate = BaseTable.parseDateWithFormat(recordValue, searchValue?.dateSearchFormat, ValueType.Date);
      if (!recordValueDate.isValid()) {
        if (type === DateFilterTypes.Blank) return true;
        if (type === DateFilterTypes.NotBlank) return false;
        if (type === DateFilterTypes.DoesNotEqual) return true;
        return false;
      }

      const searchValueDate = searchValue?.value
        ? BaseTable.parseDateWithFormat(searchValue.value, searchValue?.dateSearchFormat, ValueType.Date)
        : null;
      const hasValidSearchDate = searchValueDate && searchValueDate.isValid();

      const searchValueDate2 = searchValue?.value2
        ? BaseTable.parseDateWithFormat(searchValue.value2, searchValue?.dateSearchFormat, ValueType.Date)
        : null;
      const hasValidSearchDate2 = searchValueDate2 && searchValueDate2.isValid();

      const comparisonUnit = BaseTable.getDateComparisonUnit(searchValue?.dateSearchFormat);

      switch (type) {
        case DateFilterTypes.Equals:
          return hasValidSearchDate && recordValueDate.isSame(searchValueDate, comparisonUnit);
        case DateFilterTypes.DoesNotEqual:
          return hasValidSearchDate && !recordValueDate.isSame(searchValueDate, comparisonUnit);
        case DateFilterTypes.After:
          return hasValidSearchDate && recordValueDate.isAfter(searchValueDate, comparisonUnit);
        case DateFilterTypes.Before:
          return hasValidSearchDate && recordValueDate.isBefore(searchValueDate, comparisonUnit);
        case DateFilterTypes.Between:
          if (hasValidSearchDate && hasValidSearchDate2) {
            return recordValueDate.isBetween(searchValueDate, searchValueDate2, comparisonUnit, "[]");
          }
          return hasValidSearchDate && recordValueDate.isSame(searchValueDate, comparisonUnit);
        case DateFilterTypes.Blank:
          return !recordValue;
        case DateFilterTypes.NotBlank:
          return !!recordValue;
        default:
          return hasValidSearchDate && recordValueDate.isSame(searchValueDate, comparisonUnit);
      }
    } else if (valueType === ValueType.Boolean) {
      const normalizedRecordValue = recordValue;
      const normalizedSearchValue =
        type === "blank" || type === "number_blank" || type === "date_blank" || type === "boolean_blank"
          ? null
          : searchValue?.value;

      switch (type) {
        case BooleanFilterTypes.Equals:
          return normalizedRecordValue === normalizedSearchValue;
        case BooleanFilterTypes.DoesNotEqual:
          return normalizedRecordValue !== normalizedSearchValue;
        case BooleanFilterTypes.Blank:
          return !recordValue && recordValue !== false;
        case BooleanFilterTypes.NotBlank:
          return !!recordValue || recordValue === false;
        default:
          return normalizedRecordValue === normalizedSearchValue;
      }
    } else {
      return false;
    }
  };

  static getDefaultDateFormats = (): string[] => {
    return [
      "YYYY-MM-DDTHH:mm:ss",
      "YYYY-MM-DDTHH:mm",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DD HH:mm",
      "DD.MM.YYYY HH:mm:ss",
      "D.MM.YYYY HH:mm:ss",
      "DD.M.YYYY HH:mm:ss",
      "D.M.YYYY HH:mm:ss",
      "MM/DD/YYYY HH:mm:ss",
      "DD/MM/YYYY HH:mm:ss",
      "M/DD/YYYY HH:mm:ss",
      "DD/M/YYYY HH:mm:ss",
      "DD.MM.YYYY HH:mm",
      "D.MM.YYYY HH:mm",
      "MM/DD/YYYY HH:mm",
      "DD/MM/YYYY HH:mm",
      "DD.MM.YYYY",
      "D.MM.YYYY",
      "MM/DD/YYYY",
      "DD/MM/YYYY",
      "YYYY-MM-DD"
    ];
  };

  static parseDateWithFormat = (value: any, dateSearchFormat?: string, columnType?: ValueType) => {
    if (columnType && columnType !== ValueType.Date) return moment.invalid();
    if (!value) return moment.invalid();
    const formats: string[] = [];
    if (dateSearchFormat) {
      formats.push(dateSearchFormat);
      if (dateSearchFormat.includes(":ss")) formats.push(dateSearchFormat.replace(":ss", ""));
      if (dateSearchFormat.includes("HH:mm") && !dateSearchFormat.includes(":ss"))
        formats.push(`${dateSearchFormat}:ss`);
    }
    formats.push(...BaseTable.getDefaultDateFormats());
    const m = moment(value, formats, true);
    if (m.isValid()) return m;
    return moment(value);
  };

  static getDateComparisonUnit = (dateSearchFormat?: string): moment.unitOfTime.StartOf => {
    if (!dateSearchFormat) return "day";
    if (dateSearchFormat.includes("ss")) return "second";
    if (dateSearchFormat.includes("HH") || dateSearchFormat.includes("mm")) return "minute";
    return "day";
  };

  static isNotNull = (value: any) => {
    if (value === undefined) return false;
    if (value === null) return false;
    return true;
  };

  static mapFontWeight = (fontWeight: string): string | number => {
    const fontWeightMap: { [key: string]: string | number } = {
      Thin: 100,
      "Extra Light": 200,
      Light: 300,
      Regular: 400,
      Medium: 500,
      "Semi Bold": 600,
      Bold: 700,
      "Extra Bold": 800,
      Black: 900
    };
    return fontWeightMap[fontWeight] || fontWeight;
  };

  static compare = (value, a, b, _rowKey?: string) => {
    let x = "";
    const rowKey = _rowKey || "id";
    if (a?.id != null && Object.keys(a).every((key) => key === rowKey || a[key] == null)) {
      return 0;
    }
    if (b?.id != null && Object.keys(b).every((key) => key === rowKey || b[key] == null)) {
      return 0;
    }
    if (BaseTable.isNotNull(a) && BaseTable.isNotNull(value) && BaseTable.isNotNull(a[value])) {
      x = a[value];
      if (typeof a[value] === "string") {
        x = a[value].trim();
      }
    }
    if (!x) {
      const match = value.match(/\[(.*?)\.(.*?)\]/);
      let extractedKey = null;

      if (match && match[2]) {
        extractedKey = match[2];
      }
      if (extractedKey) {
        x = a[extractedKey];
      }
    }
    if (!BaseTable.isNotNull(x)) {
      x = "";
    }

    let y = "";
    if (BaseTable.isNotNull(b) && BaseTable.isNotNull(value) && BaseTable.isNotNull(b[value])) {
      y = b[value];
      if (typeof b[value] === "string") {
        y = b[value].trim();
      }
    }
    if (!y) {
      const match = value.match(/\[(.*?)\.(.*?)\]/);
      let extractedKey = null;

      if (match && match[2]) {
        extractedKey = match[2];
      }
      if (extractedKey) {
        y = b[extractedKey];
      }
    }

    if (!BaseTable.isNotNull(y)) {
      y = "";
    }
    const specialSortingFormats = [
      "DD/MM/YYYY HH:mm",
      "DD/MM/YYYY HH:mm:ss",
      "DD/MM/YYYY",
      "MM/DD/YYYY HH:mm",
      "MM/DD/YYYY HH:mm:ss",
      "MM/DD/YYYY",
      "HH:mm:ss",
      "HH:mm",
      "YYYY-MM-DDTHH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss.SSSZ",
      "YYYY-MM-DDTHH:mm:ss.SSSSSSSZ"
    ];

    const isValidDate = BaseTable.isDate(x, specialSortingFormats);

    if (isValidDate) {
      const specialSortingFormat = specialSortingFormats.find((format) => moment(x, format, true).isValid());
      if (specialSortingFormat) {
        if (!x || x === "") {
          return 0;
        }
        if (!y || y === "") {
          return 1;
        }
        const xDate = moment(x, specialSortingFormat);
        const yDate = moment(y, specialSortingFormat);
        return xDate.diff(yDate);
      }
    }

    if (
      (BaseTable.isNumber(x, true) || x === "" || x === undefined || x === null) &&
      (BaseTable.isNumber(y, true) || y === "" || y === undefined || y === null)
    ) {
      if ((!x && parseInt(x, 10) !== 0) || x === "") {
        return -1;
      }
      if ((!y && parseInt(y, 10) !== 0) || y === "") {
        return 1;
      }
      return Number(x) - Number(y);
    }

    if (typeof x === "string" && typeof y === "string" && x.localeCompare) {
      return x.localeCompare(y);
    }

    if (typeof x === "boolean" && typeof y === "boolean") {
      return x === y ? 0 : x ? 1 : -1;
    }

    return 0;
  };

  static isDate = (value: any, formats: any[]) => {
    if (value === undefined || value === null) return false;

    if (typeof value === "string") {
      for (const format of formats) {
        if (moment(value, format, true).isValid()) {
          return true;
        }
      }
    }

    return false;
  };

  static isNumber(r, isSort) {
    if (typeof r === "string" && !isSort) return false;
    return /^-?\d+(\.\d+)?$/.test(r);
  }

  // Strips thousand separators from a formatted number string so parseFloat/parseInt can read it.
  // Handles both US ("1,234.56") and European ("1.234,56") conventions. The hard case is a lone
  // comma or dot with exactly three digits after it ("1,000" / "1.000") — we prefer the
  // thousand-separator reading so NumberInput's default (decimalSeparator ".", thousandSeparator ",")
  // round-trips user input like 1000 correctly. See KOA-16988.
  static parseLocalizedNumberString(value: string): string {
    if (!value || typeof value !== "string") return value;
    const commaCount = (value.match(/,/g) || []).length;
    const dotCount = (value.match(/\./g) || []).length;
    if (commaCount === 0 && dotCount === 0) return value;

    if (commaCount > 0 && dotCount > 0) {
      if (value.lastIndexOf(",") > value.lastIndexOf(".")) {
        return value.replace(/\./g, "").replace(/,/g, ".");
      }
      return value.replace(/,/g, "");
    }

    if (commaCount > 0) {
      if (commaCount > 1) return value.replace(/,/g, "");
      const afterComma = value.substring(value.lastIndexOf(",") + 1);
      if (/^\d{3}$/.test(afterComma)) return value.replace(/,/g, "");
      return value.replace(/,/g, ".");
    }

    if (dotCount > 1) return value.replace(/\./g, "");
    return value;
  }

  static getValueType(value: any, dataType?: ValueType) {
    const specialSortingFormats = [
      "DD/MM/YYYY HH:mm",
      "DD/MM/YYYY HH:mm:ss",
      "DD/MM/YYYY",
      "MM/DD/YYYY HH:mm",
      "MM/DD/YYYY HH:mm:ss",
      "MM/DD/YYYY",
      "HH:mm:ss",
      "HH:mm",
      "YYYY-MM-DDTHH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss.SSSZ",
      "YYYY-MM-DDTHH:mm:ss.SSSSSSSZ"
    ];
    if (typeof value === "boolean" || value === "true" || value === "false") {
      return ValueType.Boolean;
    }
    if (BaseTable.isDate(value, specialSortingFormats)) {
      return ValueType.Date;
    }
    if (BaseTable.isNumber(value, false)) {
      return ValueType.Number;
    }
    if (!value || value === "" || value === null || value === undefined) {
      return dataType;
    }
    return ValueType.String;
  }

  static setGalleryItem = (result: Partial<ITableState>, children: any) => {
    result.rowRenderer = (props: any) => {
      return <GalleryItem {...props}></GalleryItem>;
    };
    const columnProps: TableDataProps & CommonProps = {};
    columnProps.render = (_value: any, rowData: any, rowIndex: number) => {
      return (
        <TableData rowIndex={rowIndex} rowData={rowData}>
          {children}
        </TableData>
      );
    };
    result?.columns?.push(columnProps);
  };

  static setCarouselItem = (result: Partial<ITableState>, children: any) => {
    result.rowRenderer = (props: any) => {
      return <CarouselItem {...props}></CarouselItem>;
    };
    const columnProps: TableDataProps & CommonProps = {};

    columnProps.render = (_value: any, rowData: any, rowIndex: number) => (
      <TableData rowIndex={rowIndex} rowData={rowData}>
        {children}
      </TableData>
    );
    result?.columns?.push(columnProps);
  };

  static setGoogleMapsItem = (result: Partial<ITableState>, children: any, nextProps: ITableProps) => {
    let rowPopoverRenderer: any | undefined;

    React.Children.forEach(nextProps.children, (child, childIndex) => {
      switch (childIndex) {
        // GoogleMapsMarkerPopup
        case 1:
          rowPopoverRenderer = (_value: any, rowData: any, rowIndex: number) => {
            return (
              <TableData
                rowIndex={rowIndex}
                rowData={rowData}
                markerDetailHeight={nextProps.markerDetailHeight}
                markerDetailWidth={nextProps.markerDetailWidth}
              >
                {React.cloneElement(
                  child,
                  {
                    ...child.props,
                    markerDetailWidth: nextProps.markerDetailWidth,
                    markerDetailHeight: nextProps.markerDetailHeight
                  },
                  child.props.children
                )}
              </TableData>
            );
          };
      }
    });

    result.rowRenderer = (props: any) => {
      return <GoogleMapsItem {...props} rowPopoverRenderer={rowPopoverRenderer}></GoogleMapsItem>;
    };
    const columnProps: TableDataProps & CommonProps = {};

    columnProps.render = (_value: any, rowData: any, rowIndex: number) => (
      <TableData rowIndex={rowIndex} rowData={rowData}>
        {children}
      </TableData>
    );
    result?.columns?.push(columnProps);
  };

  static refreshGoogleMapsItem: ((nextProps?: any, callBack?: any) => void) | undefined;

  static setFlexGridItem = (result: Partial<ITableState>, children: any) => {
    result.rowRenderer = (props: any) => {
      return <FlexGridItem {...props}></FlexGridItem>;
    };
    const columnProps: TableDataProps & CommonProps = {};

    columnProps.render = (_value: any, rowData: any, rowIndex: number) => (
      <TableData rowIndex={rowIndex} rowData={rowData}>
        {children}
      </TableData>
    );
    result?.columns?.push(columnProps);
  };

  setStyle = (_props?: ITableProps) => {
    const node: Element | null | Text = ReactDOM.findDOMNode(this);
    if (!node) {
      return;
    }
    const table = (node as Element).querySelectorAll("div > div > div > div > div > table");
    this.setBackgroundColor(table);
    const tbody = (node as Element).querySelectorAll("div > div > div > div > div > tbody");
    this.setBackgroundColor(tbody);
    const tdList = (node as Element).querySelectorAll("div > div > div > div > div > table > tbody > tr > td");
    tdList.forEach((td: any, index: number) => {
      this.setBackgroundColor(td);
      if (this.props.mode === "table") {
        this.setAlignments(td, index);
      }
    });
    if (this.props.mode === "table") {
      this.setDynamicStyle();
    }
  };

  getDynamicCss = (): string => {
    const className: string = this.getClassName();
    if (!className || className.length === 0) {
      return "";
    }
    let result = "";
    const { maxHeight, boxShadow, height, minHeight, padding, paddingRight, paddingLeft, paddingTop, paddingBottom } =
      this.props.style;
    const hasFixedColumns = this.state.columns?.some((col: any) => col.fixed === "left" || col.fixed === "right");

    if (window.kuika?.dashboardState === 17) {
      const { borderWidth, borderColor, borderLeftWidth, borderRightWidth, borderTopWidth, borderBottomWidth } =
        this.props.style;
      if (borderWidth || borderColor) {
        result += `.${className.trim()} .ant-table-content {
              border-left-width: ${borderLeftWidth}${borderLeftWidth ? "px" : ""} !important;
              border-right-width: ${borderRightWidth}${borderRightWidth ? "px" : ""} !important;
              border-top-width: ${borderTopWidth}${borderTopWidth ? "px" : ""} !important;
              border-bottom-width: ${borderBottomWidth}${borderBottomWidth ? "px" : ""} !important;
              border-color: ${borderColor} !important;
              border-style: solid !important;
            }`;
        result += `.${className.trim()} .ant-table-content table {
              border: none !important;
            }`;
      }
    }

    if (maxHeight || height || minHeight) {
      if (height) {
        result += `.${className.trim()} .ant-table-wrapper {
              height: ${height} !important;
            }`;
        result += `.${className.trim()} .ant-table-content table {
              min-height: ${height} !important;
            }`;
      }
      if (minHeight) {
        result += `.${className.trim()} .ant-table-wrapper {
              min-height: ${minHeight} !important;
            }`;
      }
      if (maxHeight) {
        result += `.${className.trim()} .ant-table-wrapper {
                max-height: ${maxHeight} !important;
                overflow-y: scroll !important;
              }`;
      }
      if (height || maxHeight) {
        if (this.props.pagination) {
          result += `.${className.trim()} .ant-pagination {
              background: white;
              position: sticky;
              bottom: 0;
              margin-bottom: 0 !important;
              height: 36px;
              align-items: center;
              margin-right: 2px !important;
                }`;
        }
      }
    }

    result += `.${className.trim()} table {
        border-radius: ${this.props.style?.borderRadius ?? 0}px !important;
      }`;

    if (this.props.fixedHeader && !hasFixedColumns) {
      result += `.${className.trim()} .ant-table-thead {
            position: sticky;
            top: 0;
            background: #fff;
            z-index: 5;
        }`;
    } else if (this.props.fixedHeader && hasFixedColumns) {
      result += `.${className.trim()} .ant-table-header table {
            table-layout: auto !important;
        }`;

      if (maxHeight || height || minHeight) {
        if (height) {
          result += `.${className.trim()} .ant-table-wrapper {
              height: auto !important;
            }`;
        }
        if (maxHeight) {
          result += `.${className.trim()} .ant-table-wrapper {
                max-height: none !important;
                overflow-y: hidden !important;
              }`;
        }
      }
    }

    if (this.props.searchable && this.props.sorter && !this.props.filtering) {
      result += `.${className.trim()} .ant-table-thead > tr > th > .ant-table-column-sorters {
            padding-bottom: 36px;
        }`;
    }

    if (boxShadow && !this.props.pagination) {
      result += `.${className.trim()} {
          box-shadow: ${boxShadow} !important;
        }`;
    }

    if (this.props?.striped) {
      result += `.${className.trim()} table tr:nth-child(2n) {
            background-color: #F5F7FA;
        }`;
    }

    if (this.props?.striped && this.props?.stripedColor) {
      result += `.${className.trim()} table tr:nth-child(2n) {
            background-color: ${this.props?.stripedColor};
        }`;
    }

    if (
      (padding || paddingRight || paddingLeft || paddingTop || paddingBottom) &&
      window?.kuika?.dashboardState === DashboardState.reportDesigner
    ) {
      result += `.${className.trim()} .ant-table {
          padding: ${paddingTop ?? 0}px ${paddingRight ?? 0}px ${paddingBottom ?? 0}px ${paddingLeft ?? 0}px !important;
        }`;
    }

    if (window?.kuika?.dashboardState !== DashboardState.reportDesigner) {
      if (this.props.tableWidthMode === "horizontal scroll" || this.props.tableWidthMode === "scroll") {
        result += `
        .${className.trim()} .ant-table-wrapper,
        .${className.trim()} .ant-spin-nested-loading,
        .${className.trim()} .ant-spin-container,
        .${className.trim()} .ant-table,
        .${className.trim()} .ant-table-container {
          width: 100% !important;
          max-width: 100% !important;
          overflow: visible !important;
        }
        .${className.trim()} .ant-table-content {
          width: 100% !important;
          max-width: 100% !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          -webkit-overflow-scrolling: touch !important;
        }
      `;
      } else {
        result += `.${className.trim()} .ant-table-wrapper {
        overflow-x: hidden !important;
        overflow-y: auto !important;
      }
      .${className.trim()} .ant-table-content {
        overflow-x: auto !important;
      }`;
      }
    }

    if (this.props.paginationUnselectedTextColor) {
      result += `.${className.trim()} .ant-pagination .ant-pagination-item {
        color: ${this.props.paginationUnselectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-item a {
        color: ${this.props.paginationUnselectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
      .${className.trim()} .ant-pagination .ant-pagination-next .ant-pagination-item-link {
        color: ${this.props.paginationUnselectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-total-text {
        color: ${this.props.paginationUnselectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-options .ant-pagination-options-size-changer {
        color: ${this.props.paginationUnselectedTextColor} !important;
      }`;

      result += `.${className.trim()} .ant-pagination .ant-pagination-options-size-changer .ant-select-selector .ant-select-selection-item {
        color: ${this.props.paginationUnselectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-options-size-changer .ant-select-arrow {
        color: ${this.props.paginationUnselectedTextColor} !important;
      }`;
    }

    if (this.props.paginationSelectedTextColor) {
      result += `.${className.trim()} .ant-pagination .ant-pagination-item-active {
        color: ${this.props.paginationSelectedTextColor} !important;
        border-color: ${this.props.paginationSelectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-item-active a {
        color: ${this.props.paginationSelectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-item:hover {
        color: ${this.props.paginationSelectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-item:hover a {
        color: ${this.props.paginationSelectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-prev:hover .ant-pagination-item-link,
      .${className.trim()} .ant-pagination .ant-pagination-next:hover .ant-pagination-item-link {
        color: ${this.props.paginationSelectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-item-link-icon {
        color: ${this.props.paginationSelectedTextColor} !important;
      }`;
      result += `.${className.trim()} .ant-pagination .ant-pagination-options-size-changer .ant-select-selector:hover,
      .${className.trim()} .ant-pagination .ant-pagination-options-size-changer .ant-select-selector:focus,
      .${className.trim()} .ant-pagination .ant-pagination-options-size-changer .ant-select-selector:active,
      .${className.trim()} .ant-pagination .ant-pagination-options-size-changer.ant-select-focused .ant-select-selector {
        border-color: ${this.props.paginationSelectedTextColor} !important;
        box-shadow: none !important;
      }`;
    }

    if (
      this.state.headerStyle?.borderWidth ||
      this.state.headerStyle?.borderBottomWidth ||
      this.state.headerStyle?.borderTopWidth ||
      this.state.headerStyle?.borderLeftWidth ||
      this.state.headerStyle?.borderRightWidth
    ) {
      result += `.${className.trim()} .ant-table-thead > tr > th::before {
        content: none !important;
      }`;
    }

    if (window.kuika?.dashboardState === DashboardState.reportDesigner && this.state.headerStyle?.borderColor) {
      result += `.${className.trim()} .ant-table-thead > tr > th::before {
        background-color: ${this.state.headerStyle.borderColor} !important;
      }`;
    }

    if (window.kuika?.dashboardState === DashboardState.reportDesigner) {
      this.state.columns?.forEach((col: any, index: number) => {
        const colPaddingLeft = col?.style?.paddingLeft ?? 0;
        result += `.${className.trim()} .ant-table-thead > tr > th:nth-child(${index + 1}) {
          padding-left: ${colPaddingLeft}px !important;
        }`;
      });
    }

    const dataSourceLength = this.getFilteredAndSortedDataSource()?.length || 0;
    const totalPages = Math.ceil(dataSourceLength / this.state.pageSize);

    if (totalPages <= 1 && !window.kuika?.isDesignTime) {
      result += `.${className.trim()} .ant-pagination-prev, .${className.trim()} .ant-pagination-next, .${className.trim()} .ant-pagination-item {
        display: none;
      }`;
    }

    return result;
  };

  setDynamicStyle = () => {
    this.style.setDynamicCss(this.getDynamicCss());
  };

  getClassName = () => {
    let result = "";
    if (!this.state.uniqueKey) {
      return result;
    }
    result = `${result} ktable_${this.state.uniqueKey.toString().substring(0, 8)}`;
    return result;
  };

  hideNoDataIfNotNeeded = (props: any) => {
    if (!props.showNoDataFound) {
      const node = document.getElementById(props.id);
      if (node) {
        const empty: HTMLCollectionOf<Element> = node.getElementsByClassName("ant-empty");
        if (empty.length > 0) {
          (empty[0] as HTMLElement).style.display = "none";
        }
      }
    }
  };

  setBackgroundColor = (element: any, props?: any) => {
    if (props && props.style && props.style.backgroundColor) {
      element.style["background-color"] = props.style.backgroundColor;
    }
  };

  setAlignments = (element: any, index: number) => {
    const isDesignTime = window.kuika?.isDesignTime;
    let columnStyles: React.CSSProperties = {};
    let elementsDirection: "horizontal" | "vertical" | undefined;
    if (this.props?.children[1]?.props?.children?.length > 0) {
      const columnIndex = index % this.props?.children[1]?.props?.children.length;
      const columnProps = this.props?.children[1]?.props?.children[columnIndex]?.props;
      columnStyles = columnProps?.style;
      elementsDirection = columnProps?.elementsDirection;
    }
    let node: any = element.firstChild;
    if (!node) {
      return;
    }
    if (!isDesignTime) {
      node = element;
    }
    KMainFunctions.handleAlignments(node, columnStyles, false, elementsDirection);
    if (!isDesignTime) {
      node.style.display = "table-cell";
      node.style.verticalAlign =
        columnStyles.alignItems === "center"
          ? "middle"
          : columnStyles.alignItems === "flex-end"
            ? "bottom"
            : columnStyles.alignItems === "flex-start"
              ? "top"
              : "center";
    }
  };

  // Decide whether a re-render should trigger a fixed-header column-width resync.
  // Only inputs that actually affect column geometry count. Previously this used
  // `prevProps !== this.props`, which is a new object reference on essentially every
  // parent render, so the table re-measured (and visibly reshuffled) its columns on
  // every unrelated change — the "widths don't hold on the smallest change" half of
  // KOA-16782. Layout-relevant props are compared by value so unrelated prop churn
  // (event-handler identity, selectedValues, hover state, etc.) no longer resyncs.
  static shouldResyncColumnWidths(
    prevProps: ITableProps,
    nextProps: ITableProps,
    prevState: ITableState | undefined,
    nextState: ITableState
  ): boolean {
    const stateChanged: boolean =
      prevState?.columns !== nextState.columns ||
      prevState?.hiddenColumnList !== nextState.hiddenColumnList ||
      prevState?.columnOrder !== nextState.columnOrder ||
      prevState?.columnWidths !== nextState.columnWidths ||
      prevState?.pageSize !== nextState.pageSize ||
      prevState?.current !== nextState.current;
    if (stateChanged) {
      return true;
    }

    const propChanged: boolean =
      prevProps.fixedHeader !== nextProps.fixedHeader ||
      prevProps.mode !== nextProps.mode ||
      prevProps.tableWidthMode !== nextProps.tableWidthMode ||
      prevProps.showRowNumbers !== nextProps.showRowNumbers ||
      prevProps.multiSelect !== nextProps.multiSelect ||
      prevProps.size !== nextProps.size ||
      prevProps.pagination !== nextProps.pagination ||
      prevProps.pageSize !== nextProps.pageSize ||
      prevProps.dataSource !== nextProps.dataSource;
    if (propChanged) {
      return true;
    }

    // Container dimensions drive the width available for column sizing.
    const prevStyle = prevProps.style ?? {};
    const nextStyle = nextProps.style ?? {};
    return (
      prevStyle.width !== nextStyle.width ||
      prevStyle.height !== nextStyle.height ||
      prevStyle.minHeight !== nextStyle.minHeight ||
      prevStyle.maxHeight !== nextStyle.maxHeight
    );
  }

  componentDidUpdate(prevProps: ITableProps, prevState: any) {
    this.setStyle(prevProps);
    this.hideNoDataIfNotNeeded(prevProps);

    if (prevProps.selectedValues !== this.props.selectedValues) {
      const selectedRowKeys =
        this.props.selectedValues && (this.props.selectedValues as any) !== ""
          ? this.props.selectedValues.split(",").map((v) => v.toLowerCase())
          : [];
      this.setState({
        selectedRowKeys,
        selectedRowKeysString: this.props.selectedValues || ""
      });
    }

    const isEql = isEqual(this.props.dataSource, prevProps.dataSource);
    if (this.state.activeEditableRowIndex != -1 && !isEql && !window.kuika?.isDesignTime) {
      let formValues = {};
      const filteredList = this.getFilteredAndSortedDataSource();
      let rowValue = filteredList[this.state.activeEditableRowIndex];
      if (rowValue) {
        Object.keys(rowValue).forEach((cellfieldName) => {
          let key = `Table_${this.props.id}_${cellfieldName}`;
          formValues[key] = rowValue[cellfieldName];
        });
        this.props.form?.setFieldsValue(formValues);
        this.randomGuid = Guid.create().toString();
        this.setState({ activeEditableRowIndex: -1 } as any);
      }
    } else if (
      this.state.activeEditableRowIndex != -1 &&
      isEql &&
      prevState?.activeEditableRowIndex != -1 &&
      !window.kuika.isDesignTime
    ) {
      this.randomGuid = Guid.create().toString();
      this.setState({ activeEditableRowIndex: -1 } as any);
    }

    if (!isEql && this.props.editableAlwaysActive) {
      let formValues = {};
      this.props.dataSource?.forEach((rowValue, rowIndex) => {
        Object.keys(rowValue).forEach((cellfieldName) => {
          let key = `Table_${this.props.id}_${cellfieldName}`;
          formValues[key] = rowValue[cellfieldName];
        });
        this.props.form?.setFieldsValue(formValues);
      });
      this.randomGuid = Guid.create().toString();
    }

    const shouldSyncColumnWidths: boolean = BaseTable.shouldResyncColumnWidths(
      prevProps,
      this.props,
      prevState,
      this.state
    );

    if (shouldSyncColumnWidths) {
      this.requestSyncColumnWidths();
    }
  }

  componentWillUnmount(): void {
    if (this.syncWidthsTimerId !== undefined) {
      clearTimeout(this.syncWidthsTimerId);
    }
    if (this.tableElement) {
      this.tableElement.removeEventListener("keydown", this.handleKeyDown);
      this.tableElement.removeEventListener("click", this.handleClick);
      this.tableElement.removeEventListener("keydown", this.handleTableKeyDown);
      this.tableElement = null;
    }

    window.removeEventListener("mousemove", this.resizeListener);
  }

  componentDidMount = () => {
    this.setStyle(this.props);
    this.hideNoDataIfNotNeeded(this.props);
    this.setState({
      pageSize: this.props.pageSize && this.props.pageSize >= 1 ? this.props.pageSize : 10
    });

    setTimeout(() => {
      const tableElement = document.getElementById(this.props.id);
      if (tableElement) {
        tableElement.addEventListener("keydown", this.handleKeyDown);
        tableElement.addEventListener("click", this.handleClick);
        tableElement.addEventListener("keydown", this.handleTableKeyDown);

        this.tableElement = tableElement;
      }

      this.requestSyncColumnWidths();
    }, 100);
  };

  getRowBgColor = (rowData: any, rowIndex?: number): string | undefined => {
    if (!rowData) return undefined;
    if (
      this.state.selectedRowKeys?.some((k) => k?.toString()?.toLowerCase() === rowData.id?.toString()?.toLowerCase()) &&
      this.props.selectedRowColor
    ) {
      return this.props.selectedRowColor;
    }
    if (this.props.rowBgColor) {
      return this.props.rowBgColor(rowData, rowIndex);
    }
    return undefined;
  };

  getRowFontColor = (rowData: any, rowIndex?: number): string | undefined => {
    if (this.props.rowFontColor) {
      return this.props.rowFontColor(rowData, rowIndex);
    }
    return undefined;
  };

  getRowStyle = (rowValue: any, index: number | undefined): any | undefined => {
    let style: any | undefined = _.clone(this.state.rowStyle);
    if (!style) {
      style = {};
    }
    const color = this.getRowFontColor(rowValue, index);
    if (color) {
      style.color = color;
    }
    const backgroundColor = this.getRowBgColor(rowValue, index);
    if (backgroundColor) {
      style.backgroundColor = backgroundColor;
    }
    return style;
  };

  getViewWrapper = () => {
    switch (this.props.mode) {
      case "table":
        return (props) => (
          <TableViewWrapper
            {...props}
            style={this.props.style}
            scrollable={this.props.tableWidthMode === "horizontal scroll" || this.props.tableWidthMode === "scroll"}
          ></TableViewWrapper>
        );
      case "carousel":
        return (props) => <CarouselViewWrapper {...props} style={this.props.style}></CarouselViewWrapper>;
      case "google-maps":
        return (props) => <GoogleMapsViewWrapper {...props} style={this.props.style}></GoogleMapsViewWrapper>;
      case "gallery":
        return (props) => <GalleryViewWrapper {...props} style={this.props.style}></GalleryViewWrapper>;
      case "flex-grid":
        return (props) => <FlexGridViewWrapper {...props} style={this.props.style} />;
    }
  };

  refreshGoogleMapsBodyWrapper: ((nextProps?: any, callBack?: any) => void) | undefined;

  getBodyWrapper = () => {
    switch (this.props.mode) {
      case "table":
        return TableBodyWrapper;
      case "carousel":
        return (props) => (
          <CarouselBodyWrapper
            {...props}
            {...this.getCarouselBodyWrapperProps()}
            setCurrentSlideNumber={(val: any) => {
              this.setState({ carouselStartingIndex: val });
            }}
            startingIndex={this.state.carouselStartingIndex}
          />
        );
      case "google-maps":
        return (props) => (
          <RefreshDelegate
            {...props}
            setRefreshDelegate={(refreshMethod) => {
              this.refreshGoogleMapsBodyWrapper = refreshMethod;
            }}
            {...this.getGoogleMapsBodyWrapperProps()}
            Component={GoogleMapsBodyWrapper}
          />
        );
      case "gallery":
        return (props) => <GalleryBodyWrapper {...props} {...this.getGalleryBodyWrapperProps()}></GalleryBodyWrapper>;
      case "flex-grid":
        return (props) => <FlexGridBodyWrapper {...props} {...this.getGalleryBodyWrapperProps()} />;
    }
  };

  getBodyCell = () => {
    switch (this.props.mode) {
      case "table":
        return (props) => <TableBodyCell {...props} parentTable={this} />;
      case "carousel":
        return CarouselBodyCell;
      case "google-maps":
        return GoogleMapsBodyCell;
      case "gallery":
        return GalleryBodyCell;
      case "flex-grid":
        return FlexGridBodyCell;
    }
  };

  getCarouselBodyWrapperProps = () => {
    const result: CarouselBodyWrapperProps = {};
    const p = this.props as CarouselBodyWrapperProps;
    if (p.autoplaySpeed) result.autoplaySpeed = p.autoplaySpeed;
    if (p.autoplay) result.autoplay = p.autoplay;
    if (p.fade) result.fade = p.fade;
    if (p.pauseOnDotsHover) result.pauseOnDotsHover = p.pauseOnDotsHover;
    if (p.slidesToScroll) result.slidesToScroll = p.slidesToScroll;
    if (p.dots === false) {
      result.dots = false;
    }
    if (p.dots === undefined || p.dots === true) {
      result.dots = true;
    }
    if (p.slidesToShow) result.slidesToShow = p.slidesToShow;
    if (p.speed) result.speed = p.speed;
    if (p.swipe) result.swipe = p.swipe;
    if (p.cssEase) result.cssEase = p.cssEase;
    if (p.vertical) result.vertical = p.vertical;
    if (p.onChange) result.onChange = p.onChange;
    if (p.startingIndex && p.startingIndex > 0) {
      result.startingIndex = p.startingIndex;
      this.setState({ carouselStartingIndex: p.startingIndex as any });
    }
    if (p.hoverBgColor) result.hoverBgColor = p.hoverBgColor;
    if (p.hoverFontColor) result.hoverFontColor = p.hoverFontColor;
    if (p.arrowColor) result.arrowColor = p.arrowColor;
    if (p.showPageIndicator !== undefined) result.showPageIndicator = p.showPageIndicator;
    if (this.props.dataSource) result.totalSlides = this.props.dataSource.length;
    return result;
  };

  getLatValue = () => {
    if (this.lastSelectedLat !== undefined) {
      return this.lastSelectedLat;
    }
    return "";
  };

  getLngValue = () => {
    if (this.lastSelectedLng !== undefined) {
      return this.lastSelectedLng;
    }
    return "";
  };

  getGoogleMapsBodyWrapperProps = () => {
    const result: GoogleMapsBodyWrapperProps = {} as any;
    const p = this.props;
    result.value = this.state.value;
    if (p.style) result.style = p.style;
    if (p.latitude) result.latitude = p.latitude;
    if (p.longitude) result.longitude = p.longitude;
    if (p.zoom) result.zoom = p.zoom;
    if (p.dataLatField) result.dataLatField = p.dataLatField;
    if (p.dataLngField) result.dataLngField = p.dataLngField;
    if (p.markerDetailView) result.markerDetailView = p.markerDetailView;
    if (p.markerDetailPosition) result.markerDetailPosition = p.markerDetailPosition;
    if (p.markerDetailHeight) result.markerDetailHeight = p.markerDetailHeight;
    if (p.markerDetailWidth) result.markerDetailWidth = p.markerDetailWidth;
    if (p.designClicked) result.designClicked = p.designClicked;
    result.isPicker = p.isPicker;
    result.isMarkerPicker = p.isMarkerPicker;
    result.hasSearchBox = p.hasSearchBox;
    result.disableDoubleClickZoom = p.disableDoubleClickZoom;
    result.fullScreenControlV1 = p.fullScreenControlV1;
    result.streetViewControlV1 = p.streetViewControlV1;
    result.scaleControlV1 = p.scaleControlV1;
    result.zoomControlV1 = p.zoomControlV1;
    result.panControl = p.panControl;
    result.rotateControlV1 = p.rotateControlV1;
    result.cameraControl = p.cameraControl;
    result.mapTypeControl = p.mapTypeControl;
    result.autoCenter = p.autoCenter;
    result.circleRadius = p.circleRadius;
    result.mapType = p.mapType;
    result.hideTrafficLayer = p.hideTrafficLayer;
    result.hideTransitLayer = p.hideTransitLayer;
    result.enableLocationTracking = p.enableLocationTracking;
    result.waypointLatField = p.waypointLatField;
    result.waypointLngField = p.waypointLngField;
    result.waypoints = p.waypoints;
    result.onClusterElementClicked = (e, rowValue, rowData) => {
      this.setState({ isDataMarkerSelected: true as any }, () => {
        this.handleRowClick(e, rowValue, rowData);
      });
    };

    result.clearActiveContent = () => {
      if (this.refreshGoogleMapsBodyWrapper) {
        this.refreshGoogleMapsBodyWrapper({
          activeContent: undefined,
          designClicked: false
        });
      }
    };
    result.onChange = (isDataMarkerSelected: boolean, value?: ICoords) => {
      this.setState({ value, isDataMarkerSelected } as any, () => {
        if (this.refreshGoogleMapsBodyWrapper) {
          let wrapperProps: any = { value, isDataMarkerSelected };
          if (isDataMarkerSelected !== true) {
            wrapperProps = {
              value,
              isDataMarkerSelected,
              activeContent: undefined
            };
          }
          this.refreshGoogleMapsBodyWrapper(wrapperProps, () => {
            if (p.onChange) {
              this.lastSelectedLat = value?.latitude;
              this.lastSelectedLng = value?.longitude;
              p.onChange(value);
            }
          });
        }
      });
    };
    result.onGoogleApiLoaded = (map: any, maps: any) => {
      this.setState({ map, maps }, () => {
        if (this.refreshGoogleMapsBodyWrapper) {
          this.refreshGoogleMapsBodyWrapper({ map, maps }, () => {});
        }
      });
    };
    result.maps = this.state.maps;
    result.map = this.state.map;
    result.isDataMarkerSelected = this.state.isDataMarkerSelected;
    result.groupPickerIcon = p.groupPickerIcon;
    result.groupPickerColor = p.groupPickerColor;
    result.currentLocationIcon = p.currentLocationIcon;
    result.currentLocationColor = p.currentLocationColor;
    return result;
  };

  getGalleryBodyWrapperProps = () => {
    const result: GalleryBodyWrapperProps = {};
    const p = this.props as GalleryBodyWrapperProps;
    if (p.horizontalGutter) result.horizontalGutter = p.horizontalGutter;
    if (p.verticalGutter) result.verticalGutter = p.verticalGutter;
    return result;
  };

  public getSelectedIndex = () => {
    const selectedIndexHiddenInput = this.getSelectedRowIndexHiddenInput();

    if (selectedIndexHiddenInput) {
      return selectedIndexHiddenInput.value;
    }
  };

  public getSelectedValues = () => {
    return this.state.selectedRowKeysString;
  };

  public getSelectedCount = () => {
    return this.state.selectedRowKeys?.length || 0;
  };

  getNestedTableSelectedIndex = (parentTableDomEl: HTMLElement) => {
    const selectedIndex = this.getSelectedIndex();

    const tbody = parentTableDomEl.querySelector(".ant-table-tbody");

    if (!tbody) {
      return;
    }

    const rows = tbody.querySelectorAll(`:scope > [tableclassname="${this.getClassName().trim()}"]`);

    if (rows.length === 0) {
      return;
    }

    if (selectedIndex === undefined || selectedIndex === "") {
      return;
    }

    const selectedRow = rows[selectedIndex];

    const selectedIndexDom = selectedRow.querySelector(".selected-index-guid");

    if (!(selectedIndexDom instanceof HTMLInputElement)) {
      return;
    }

    return selectedIndexDom.value ?? "";
  };

  getTableWrapperFromHtmlElement = (htmlElementNode: HTMLElement): HTMLElement | undefined => {
    while (htmlElementNode) {
      htmlElementNode = htmlElementNode.parentNode as HTMLElement;

      if (htmlElementNode?.classList?.contains("ant-table")) {
        return htmlElementNode;
      }
    }

    return undefined;
  };

  getNearestTableAncestor = (htmlElementNode: HTMLElement): HTMLElement | undefined => {
    const baseTableViewWrapperElementClasses = [
      "kuika-table-view-wrapper",
      "kuika-galleryview-view-wrapper",
      "kuika-flexgrid-view-wrapper",
      "kuika-carousel-view-wrapper"
    ];

    while (htmlElementNode) {
      htmlElementNode = htmlElementNode?.parentNode as HTMLElement;

      if (!htmlElementNode) break;
      const classList = Array.from(htmlElementNode.classList ?? []);

      const hasMatchingClass = classList.some((cls) => baseTableViewWrapperElementClasses.includes(cls));

      if (hasMatchingClass) return htmlElementNode;
    }

    return undefined;
  };

  public getParentTableIdIfExist = () => {
    const currentTableElement = document.getElementById(this.props.id);
    const nearestTableAncestor = this.getNearestTableAncestor(currentTableElement);

    if (!nearestTableAncestor) {
      return;
    }

    const tableWrapper = this.getTableWrapperFromHtmlElement(nearestTableAncestor);

    return tableWrapper?.id;
  };

  getSelectedColumnIndex = () => {
    const selectedIndexHiddenInput = this.getSelectedColumnIndexHiddenInput();
    if (selectedIndexHiddenInput) {
      return selectedIndexHiddenInput.value;
    }
  };

  public getSelectedRowData = () => {
    const selectedRowDataHiddenInput = this.getSelectedRowDataHiddenInput();
    if (!this.props.dataSource || !selectedRowDataHiddenInput || !selectedRowDataHiddenInput.value) {
      return;
    }

    if (this.props.mode === "google-maps" && !this.state.isDataMarkerSelected) return;

    return JSON.parse(selectedRowDataHiddenInput.value);
  };

  public getCarouselCurrentData = () => {
    if (this.props.dataSource && this.props.mode === "carousel") {
      return this.props.dataSource[this.state.carouselStartingIndex];
    }
    return {} as any;
  };

  public getTableConfigJson = () => {
    const json = {
      searchText: this.state.searchText,
      columnSearchTexts: this.state.columnSearchTexts,
      hiddenColumnList: this.state.hiddenColumnList,
      columnOrder: this.state.columnOrder,
      filteringOptions: this.state.filteringOptions,
      sorterOptions: this.state.sorterOptions,
      columnWidths: this.state.columnWidths
    };
    return JSON.stringify(json);
  };

  public setTableConfigJson = (json: string) => {
    if (!json || json === "") return;
    const obj = JSON.parse(json);
    this.setState({
      searchText: obj.searchText,
      columnSearchTexts: obj.columnSearchTexts,
      hiddenColumnList: obj.hiddenColumnList,
      columnOrder: obj.columnOrder,
      filteringOptions: obj.filteringOptions,
      sorterOptions: obj.sorterOptions,
      columnWidths: obj.columnWidths
    });
  };

  public clearFilterConfigs = () => {
    this.setState({
      searchText: "" as any,
      columnSearchTexts: {} as any,
      filteringOptions: {},
      sorterOptions: {}
    });
  };

  public resetTableConfigs = () => {
    this.setState({
      searchText: "" as any,
      columnSearchTexts: {} as any,
      hiddenColumnList: [] as any,
      columnOrder: [] as any,
      filteringOptions: {} as any,
      sorterOptions: {} as any,
      columnWidths: {} as any
    });
  };

  public searchTable = (searchText: string) => {
    this.setState((prevState) => ({
      ...prevState,
      searchText
    }));
  };

  public exportTable = () => {
    this.onExport();
  };

  public setSelectedValues = (selectedValues: string) => {
    const cleanedValues = selectedValues?.replace(/^,|,$/g, "");
    this.setState({
      selectedRowKeysString: cleanedValues,
      selectedRowKeys: cleanedValues ? cleanedValues.split(",").map((v) => v.toLowerCase()) : []
    });
  };

  private getSelectedRowKeysForAntd = (): any[] => {
    if (!this.state.selectedRowKeys || this.state.selectedRowKeys.length === 0) return [];
    if (!this.props.dataSource) return this.state.selectedRowKeys;
    const actualRowKey = this.state.actualRowKey || "id";
    return this.props.dataSource
      .filter((row) =>
        this.state.selectedRowKeys.some(
          (k) => k?.toString()?.toLowerCase() === row[actualRowKey]?.toString()?.toLowerCase()
        )
      )
      .map((row) => row[actualRowKey]);
  };

  getSelectedRowIndexHiddenInput = () => {
    const selectedIndexHiddenInput = window.document.getElementById(this.state.selectedIndexGuid);
    return selectedIndexHiddenInput;
  };

  getSelectedColumnIndexHiddenInput = () => {
    const selectedColumnIndexHiddenInput = window.document.getElementById(this.state.selectedColumnIndexGuid);
    return selectedColumnIndexHiddenInput;
  };

  getSelectedRowDataHiddenInput = () => {
    const selectedColumnIndexHiddenInput = window.document.getElementById(this.state.selectedRowDataGuid);
    return selectedColumnIndexHiddenInput;
  };

  findAttributeInTree = (element: HTMLElement, attributeName: string, maxDepth: number = 10): string | null => {
    let currentElement = element;
    let depth = 0;

    while (currentElement && depth < maxDepth) {
      const attrValue = currentElement.getAttribute(attributeName);
      if (attrValue) {
        return attrValue;
      }

      if (currentElement.parentElement) {
        currentElement = currentElement.parentElement;
        depth++;
      } else {
        break;
      }
    }

    return null;
  };

  findRowElement = (element: HTMLElement): HTMLElement | null => {
    let currentElement = element;
    let depth = 0;
    const maxDepth = 20;

    while (currentElement && depth < maxDepth) {
      if (currentElement.tagName?.toLowerCase() === "tr") {
        return currentElement;
      }

      if (currentElement.parentElement) {
        currentElement = currentElement.parentElement;
        depth++;
      } else {
        break;
      }
    }

    return null;
  };

  getRowDataFromElement = (element: HTMLElement): any | null => {
    const rowElement = this.findRowElement(element);
    if (!rowElement) return null;

    const rowKey = rowElement.getAttribute("data-row-key");
    if (!rowKey) return null;

    const dataSource = this.getDataSource();
    const result = BaseTable.findRowByKey(dataSource, rowKey, this.props.rowKey?.toString() || "id");
    return result || null;
  };

  isInsertRow = (rowData: any): boolean => {
    if (!rowData) return false;
    const rowKey = this.props.rowKey?.toString()?.toLowerCase() || "id";
    const otherFields = Object.keys(rowData).filter((key) => key?.toString()?.toLowerCase() !== rowKey);
    return otherFields.every((field) => rowData[field] === undefined);
  };

  getFormValues = (rowData: any, isInsertRow?: boolean): { [key: string]: any } => {
    if (!rowData) return {};

    const dataToUse = isInsertRow ? this.getCurrentFirstRowInputValues() || rowData : rowData;

    const formValues: { [key: string]: any } = {};
    Object.keys(dataToUse).forEach((fieldName) => {
      const key = `Table_${this.props.id}_${fieldName}`;
      formValues[key] = dataToUse[fieldName];
    });

    return formValues;
  };

  focusNextCell = (nextColumnIndex: number, currentRowIndex: string): void => {
    setTimeout(() => {
      const tableElement = document.querySelector(`.${this.getClassName().trim()}`);
      if (!tableElement) return;

      const nextCell = tableElement.querySelector(`[rowindex="${currentRowIndex}"][columnindex="${nextColumnIndex}"]`);

      if (nextCell) {
        const input = nextCell.querySelector("input, textarea, select, .ant-select-selection-search-input");
        if (input) {
          (input as HTMLElement).focus();
        }
      }
    }, 50);
  };

  compareFormValues = (rowData: any): { isEqual: boolean; oldValues: any; newValues: any } => {
    const oldValues = {};
    const newValues = {};

    if (!rowData || !this.props.form) {
      return { isEqual: true, oldValues, newValues };
    }

    Object.keys(rowData).forEach((fieldName) => {
      const key = `Table_${this.props.id}_${fieldName}`;
      oldValues[key] = rowData[fieldName];
      newValues[key] = this.props.form?.getFieldValue(key);
    });

    return {
      isEqual: isEqual(oldValues, newValues),
      oldValues,
      newValues
    };
  };

  handleKeyDown = async (event: KeyboardEvent): Promise<void> => {
    const target = event.target as HTMLElement;
    const rowData = this.getRowDataFromElement(target);
    const isCurrentInsertRow = rowData ? this.isInsertRow(rowData) : false;
    const currentColumnIndex = this.findAttributeInTree(target, "columnindex");
    const currentRowIndex = this.findAttributeInTree(target, "rowindex");

    if (event?.key === "Escape") {
      if (this.props.editableAlwaysActive || this.state.activeEditableRowIndex !== -1) {
        this.setState({ activeEditableRowIndex: -1 } as any);
        return;
      }
    }

    if (
      event?.key === "Enter" &&
      this.state.activeEditableRowIndex !== -1 &&
      (this.props.onRowEditFinished || this.props.onInsertRowFinished)
    ) {
      event.preventDefault();
      await this.handleOnRowEditFinished(rowData);
      return;
    }

    if (!this.props.editableAlwaysActive) return;

    if (event?.key === "Tab" && isCurrentInsertRow) {
      const tableElement = document.querySelector(`.${this.getClassName().trim()}`);
      if (!tableElement || !currentColumnIndex) return;

      const nextColumnIndex = parseInt(currentColumnIndex) + 1;
      const nextCell = tableElement.querySelector(`[rowindex="0"][columnindex="${nextColumnIndex}"]`);

      if (nextCell) {
        const input = nextCell.querySelector("input, textarea, select, .ant-select-selection-search-input");
        if (input) {
          event.preventDefault();
          (input as HTMLElement).focus();
        }
      }
      return;
    }

    if (event?.key === "Enter" && isCurrentInsertRow) {
      await this.handleOnRowEditFinished(rowData);
      return;
    }

    if (event?.key === "Tab" || (event?.key === "Enter" && !isCurrentInsertRow)) {
      if (!rowData) {
        await this.handleOnRowEditFinished(rowData);
        return;
      }

      this.setFields(event, false, rowData);

      const { isEqual } = this.compareFormValues(rowData);

      if (!isEqual) {
        await this.handleOnRowEditFinished(rowData, false, event);
        if (currentColumnIndex && currentRowIndex) {
          this.handleFocusNextCell(event, currentColumnIndex, currentRowIndex, false);
        }
      }
    }
  };

  handleFocusNextCell = (
    event: KeyboardEvent,
    currentColumnIndex: string,
    currentRowIndex: string,
    isEqual: boolean
  ) => {
    if (event && event?.key === "Tab") {
      event.preventDefault();

      const tableElement = document.querySelector(`.${this.getClassName().trim()}`) as HTMLElement;
      if (!tableElement || !currentColumnIndex || !currentRowIndex) return;

      const currentRow = tableElement.querySelector(`tr[rowindex="${currentRowIndex}"]`) as HTMLElement;
      if (!currentRow) return;

      const cells = currentRow.querySelectorAll("td");
      const lastColumnIndex = cells.length - 1;

      const findNextCellWithDataValue = (startColumnIndex: number, currentRowIndex: number) => {
        const dataSource = this.getDataSource();
        if (!dataSource || dataSource.length <= currentRowIndex) {
          return { columnIndex: startColumnIndex, rowIndex: currentRowIndex };
        }

        const rowData = dataSource[currentRowIndex];
        if (!rowData) return { columnIndex: startColumnIndex, rowIndex: currentRowIndex };

        const hasInteractiveElements = (cell: HTMLElement): boolean => {
          return !!(
            cell.querySelector("input") ||
            cell.querySelector(".ant-switch") ||
            cell.querySelector(".ant-select") ||
            cell.querySelector(".ant-checkbox") ||
            cell.querySelector(".ant-radio")
          );
        };

        const row =
          currentRowIndex === parseInt(currentRowIndex.toString())
            ? currentRow
            : (tableElement.querySelector(`tr[rowindex="${currentRowIndex}"]`) as HTMLElement);

        if (!row) return { columnIndex: startColumnIndex, rowIndex: currentRowIndex };

        for (let i = startColumnIndex; i <= lastColumnIndex; i++) {
          const cellElement = row.querySelector(`td[columnindex="${i}"]`) as HTMLElement;
          if (!cellElement) continue;

          const dataValueAttr = cellElement.getAttribute("datavalue");
          const hasDataValue = dataValueAttr && rowData[dataValueAttr] !== undefined;
          const hasInteractive = hasInteractiveElements(cellElement);

          if (hasDataValue && hasInteractive) {
            return { columnIndex: i, rowIndex: currentRowIndex };
          }
        }

        const nextRowIndex = currentRowIndex + 1;
        if (dataSource.length > nextRowIndex) {
          const nextRow = tableElement.querySelector(`tr[rowindex="${nextRowIndex}"]`) as HTMLElement;
          if (nextRow) {
            for (let i = 0; i <= lastColumnIndex; i++) {
              const cellElement = nextRow.querySelector(`td[columnindex="${i}"]`) as HTMLElement;
              if (!cellElement) continue;

              const dataValueAttr = cellElement.getAttribute("datavalue");
              const hasDataValue = dataValueAttr && dataSource[nextRowIndex][dataValueAttr] !== undefined;
              const hasInteractive = hasInteractiveElements(cellElement);

              if (hasDataValue && hasInteractive) {
                return { columnIndex: i, rowIndex: nextRowIndex };
              }
            }
          }
        }

        return { columnIndex: 0, rowIndex: nextRowIndex };
      };

      const currentColumnIndexNum = parseInt(currentColumnIndex);
      const currentRowIndexNum = parseInt(currentRowIndex);

      if (isEqual) {
        const nextRowIndex = currentRowIndexNum + 1;
        const nextRow = tableElement.querySelector(`tr[rowindex="${nextRowIndex}"]`);

        if (nextRow) {
          const nextCell = findNextCellWithDataValue(0, nextRowIndex);
          const dataSource = this.getDataSource();
          const nextRowData = dataSource && dataSource.length > nextRowIndex ? dataSource[nextRowIndex] : null;

          window.nextCellToFocus = {
            tableId: this.props.id || "",
            columnIndex: nextCell.columnIndex,
            rowIndex: nextCell.rowIndex.toString()
          };

          if (nextRowData) {
            const targetCell = tableElement.querySelector(
              `td[columnindex="${nextCell.columnIndex}"][rowindex="${nextCell.rowIndex}"]`
            ) as HTMLElement;
            if (targetCell) {
              let inputElement = targetCell.querySelector("input") as HTMLInputElement;
              if (inputElement && document.activeElement !== inputElement) {
                inputElement.focus();

                if (!window.handlingCellClick) {
                  window.handlingCellClick = true;

                  const syntheticEvent = {
                    currentTarget: targetCell,
                    target: inputElement,
                    preventDefault: () => {},
                    stopPropagation: () => {}
                  };
                  this.handleCellClick(syntheticEvent as any, nextCell.columnIndex, nextRowData, nextCell.rowIndex);
                  setTimeout(() => {
                    window.handlingCellClick = false;
                    window.nextCellToFocus = null;
                  }, 500);
                }
              }
            }
          }
          return;
        }
      }

      if (currentColumnIndexNum >= lastColumnIndex) {
        const nextRowIndex = currentRowIndexNum + 1;
        const nextRow = tableElement.querySelector(`tr[rowindex="${nextRowIndex}"]`);

        if (nextRow) {
          const nextCell = findNextCellWithDataValue(0, nextRowIndex);

          window.nextCellToFocus = {
            tableId: this.props.id || "",
            columnIndex: nextCell.columnIndex,
            rowIndex: nextCell.rowIndex.toString()
          };

          const dataSource = this.getDataSource();
          if (dataSource && dataSource.length > nextCell.rowIndex) {
            const nextRowData = dataSource[nextCell.rowIndex];

            if (nextRowData) {
              setTimeout(() => {
                const targetRow = tableElement.querySelector(`tr[rowindex="${nextCell.rowIndex}"]`);
                const targetCell = targetRow?.querySelector(`td[columnindex="${nextCell.columnIndex}"]`);
                if (targetCell) {
                  const syntheticEvent = {
                    target: targetCell,
                    currentTarget: targetCell,
                    preventDefault: () => {},
                    stopPropagation: () => {}
                  };

                  setTimeout(() => {
                    this.handleCellClick(syntheticEvent as any, nextCell.columnIndex, nextRowData, nextCell.rowIndex);

                    const selectedRowDataHiddenInput = this.getSelectedRowDataHiddenInput();
                    if (selectedRowDataHiddenInput) {
                      selectedRowDataHiddenInput.value = JSON.stringify(nextRowData);
                    }

                    const selectedIndexHiddenInput = this.getSelectedRowIndexHiddenInput();
                    if (selectedIndexHiddenInput) {
                      selectedIndexHiddenInput.value = nextCell.rowIndex.toString();
                    }
                  }, 100);
                }
              }, 1000);
            }
          }
        }
      } else {
        const nextCell = findNextCellWithDataValue(currentColumnIndexNum + 1, currentRowIndexNum);

        window.nextCellToFocus = {
          tableId: this.props.id || "",
          columnIndex: nextCell.columnIndex,
          rowIndex: nextCell.rowIndex.toString()
        };

        if (nextCell.rowIndex !== currentRowIndexNum) {
          const dataSource = this.getDataSource();
          if (dataSource && dataSource.length > nextCell.rowIndex) {
            const nextRowData = dataSource[nextCell.rowIndex];
            const nextRow = tableElement.querySelector(`tr[rowindex="${nextCell.rowIndex}"]`);

            if (nextRowData && nextRow) {
              const targetCell = nextRow.querySelector(`td[columnindex="${nextCell.columnIndex}"]`);
              if (targetCell) {
                const syntheticEvent = {
                  target: targetCell,
                  currentTarget: targetCell,
                  preventDefault: () => {},
                  stopPropagation: () => {}
                };

                setTimeout(() => {
                  this.handleCellClick(syntheticEvent as any, nextCell.columnIndex, nextRowData, nextCell.rowIndex);

                  const selectedRowDataHiddenInput = this.getSelectedRowDataHiddenInput();
                  if (selectedRowDataHiddenInput) {
                    selectedRowDataHiddenInput.value = JSON.stringify(nextRowData);
                  }

                  const selectedIndexHiddenInput = this.getSelectedRowIndexHiddenInput();
                  if (selectedIndexHiddenInput) {
                    selectedIndexHiddenInput.value = nextCell.rowIndex.toString();
                  }
                }, 1000);
              }
            }
          }
        }
      }
    }
  };

  handleClick = (event: MouseEvent): void => {
    const targetId = (event?.target as HTMLElement)?.id;

    if (targetId.includes("body") || targetId.includes("header") || targetId.includes("footer")) {
      if (
        this.state.activeEditableRowIndex !== -1 &&
        (this.props.onRowEditFinished || this.props.onInsertRowFinished)
      ) {
        const rowData = this.getRowDataFromElement(event?.target as HTMLElement);
        this.handleOnRowEditFinished(rowData);
      }
    }
  };

  handleTableKeyDown = async (event: KeyboardEvent): Promise<void> => {
    if (event?.key === "Enter") {
      const rowData = this.getRowDataFromElement(event?.target as HTMLElement);
      if (
        this.state.activeEditableRowIndex !== -1 &&
        (this.props.onRowEditFinished || this.props.onInsertRowFinished)
      ) {
        event.preventDefault();
        event.stopPropagation();
        await this.handleOnRowEditFinished(rowData);
      } else if (this.props.insertRowActive) {
        await this.handleOnRowEditFinished(rowData);
      }
    }
  };

  handleOnRowEditFinished = async (rowData?: any, _isInsertRow?: boolean, event?: KeyboardEvent): Promise<void> => {
    const { pageSize = 10, current = 1 } = this.state;
    const offset = (current - 1) * pageSize;

    let rowValue: any;

    if (!this.props.editableAlwaysActive) {
      const filteredList = this.getFilteredAndSortedDataSource();
      const adjustedIndex = offset + (this.state.activeEditableRowIndex || 0);
      rowValue = filteredList?.[adjustedIndex];
    } else if (rowData) {
      rowValue = rowData;
    }

    if (!rowValue) {
      this.setState({ activeEditableRowIndex: -1 } as any);
      return;
    }

    const isInsertRow = _isInsertRow || (this.props.insertRowActive && this.isInsertRow(rowValue));

    let { oldValues, newValues } = this.compareFormValues(rowValue);

    const idColumnKey = `Table_${this.props.rowKey?.toString() || "id"}_id`;
    if (isInsertRow) {
      oldValues = {
        ...Object.keys(rowValue).reduce((acc, key) => {
          if (key !== idColumnKey) {
            acc[key] = undefined;
          }
          return acc;
        }, {})
      };
    }

    const _isEqual = isEqual(oldValues, newValues);

    if (_isEqual) {
      this.setState({ activeEditableRowIndex: -1 } as any);
      return;
    }

    if (oldValues[idColumnKey] !== newValues[idColumnKey] && !isInsertRow) {
      console.warn("Row ID should not be changed during edit");

      if (event?.key === "Tab") {
        const target = event.target as HTMLElement;
        const currentColumnIndex = this.findAttributeInTree(target, "columnindex");
        const currentRowIndex = this.findAttributeInTree(target, "rowindex");
        this.handleFocusNextCell(event, currentColumnIndex, currentRowIndex, true);
      }
      return;
    }

    if (isInsertRow && this.props.onInsertRowFinished) {
      this.props.onInsertRowFinished();
    } else if (this.props.onRowEditFinished) {
      this.props.onRowEditFinished();
    }
  };

  handleRowClick = (event: React.MouseEvent, rowValue: any, rowIndex?: number): void => {
    if (
      (this.props.onRowEditFinished || this.props.onInsertRowFinished) &&
      this.state.activeEditableRowIndex !== -1 &&
      rowIndex !== this.state.activeEditableRowIndex &&
      !this.props.editableAlwaysActive
    ) {
      const rowData = this.getRowDataFromElement(event?.target as HTMLElement);
      this.handleOnRowEditFinished(rowData);
    }

    const selectedIndexHiddenInput = this.getSelectedRowIndexHiddenInput();
    if (selectedIndexHiddenInput && rowIndex !== undefined) {
      selectedIndexHiddenInput.value = rowIndex.toString();
    }

    const selectedRowDataHiddenInput = this.getSelectedRowDataHiddenInput();
    if (selectedRowDataHiddenInput && rowValue !== undefined) {
      selectedRowDataHiddenInput.value = JSON.stringify(rowValue);
    }
  };

  handleRowDoubleClick = (event: React.MouseEvent, rowValue: any, rowIndex?: number): void => {
    if (this.props.editableAlwaysActive) {
      return;
    }

    if (this.state.activeEditableRowIndex !== rowIndex && this.props.editable) {
      const isEditable = this.props.children[1]?.props?.editabilityCondition?.(rowValue) ?? true;

      if (!isEditable) {
        return;
      }

      const formValues = this.getFormValues(rowValue);
      this.props.form?.setFieldsValue(formValues);

      this.setState({ activeEditableRowIndex: rowIndex } as any);
    }

    if (this.props.onRowDoubleClick) {
      this.props.onRowDoubleClick();
    }
  };

  handleOnRowBlur = (event: React.FocusEvent, rowValue: any, rowIndex?: number): void => {};

  handleCellClick = (event: React.MouseEvent, columnIndex: number, rowData: any, rowIndex: number): void => {
    if (this.props.editableAlwaysActive) {
      this.setFields(event, true, rowData);
    }

    const selectedColumnIndexHiddenInput = this.getSelectedColumnIndexHiddenInput();
    if (selectedColumnIndexHiddenInput && columnIndex !== undefined) {
      selectedColumnIndexHiddenInput.value = columnIndex.toString();
    }
  };

  getColumnDataFromEvent = (
    event: any
  ): {
    dataValue: string | null;
    dataType: string | null;
    element: HTMLElement;
    columnIndex: string | null;
  } => {
    let dataValue = event?.target?.getAttribute("datavalue");
    let dataType = event?.target?.getAttribute("datatype");
    let element = event?.target;
    const columnIndex = event?.target?.getAttribute("columnindex");

    while (!dataValue && element && element.getAttribute("datavalue") === null) {
      element = element.parentElement;
      if (!element) break;

      dataValue = element?.getAttribute("datavalue");
      dataType = element?.getAttribute("datatype");
    }

    return { dataValue, dataType, element, columnIndex };
  };

  isBooleanElement = (element: HTMLElement): boolean => {
    return (
      element?.getAttribute("aria-checked") === "true" ||
      element?.getAttribute("aria-checked") === "false" ||
      element?.parentElement?.getAttribute("aria-checked") === "true" ||
      element?.parentElement?.getAttribute("aria-checked") === "false"
    );
  };

  isCheckboxElement = (element: HTMLElement): boolean => {
    return element.className === "ant-checkbox-inner" || element.className === "ant-checkbox-input";
  };

  getColumnValue = (
    event: any,
    dataType: string,
    element: HTMLElement
  ): {
    value: any;
    isDate: boolean;
    isBoolean: boolean;
    isSelect: boolean;
    selectedValue?: any;
  } => {
    let currentValue: any =
      (event.target as HTMLInputElement)?.value?.toString()?.trim() ||
      (document.activeElement as HTMLInputElement)?.checked ||
      (document.activeElement as HTMLInputElement)?.value;
    let selectedValue: any;
    const isDateType = currentValue && typeof currentValue === "string" && dataType === ValueType.Date;
    const isBooleanType = this.isBooleanElement(event?.target);
    let isSelect = false;

    if (event?.target?.className === "ant-select-item-option-content") {
      let selectedOptionElement = event.target?.parentElement;
      if (selectedOptionElement && selectedOptionElement.getAttribute("aria-selected") === "true") {
        currentValue = event?.target?.textContent;
      } else {
        const parentWithSelection = event.target?.parentElement?.parentElement?.querySelector('[aria-selected="true"]');
        if (parentWithSelection) {
          currentValue = parentWithSelection.getAttribute("data-value");
          selectedValue = selectedOptionElement?.getAttribute?.("data-value");
        }
      }
      isSelect = true;
    }

    if (isDateType) {
      currentValue = moment(currentValue, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
    }

    if (isBooleanType) {
      currentValue = !(
        event.target.parentElement?.getAttribute("aria-checked") === "true" ||
        event.target?.getAttribute("aria-checked") === "true"
      );
    }

    if (this.isCheckboxElement(event.target)) {
      const parent = event.target.parentElement;
      const input = parent?.querySelector("input");
      if (input) {
        currentValue = input.getAttribute("checked") === null;
      }
    }

    if (currentValue && typeof currentValue === "string") {
      if (dataType === ValueType.Number) {
        currentValue = BaseTable.parseLocalizedNumberString(currentValue);
      } else {
        currentValue = currentValue.replace(/[,]/g, "");
      }
    }

    return {
      value: currentValue,
      isDate: isDateType,
      isBoolean: isBooleanType || this.isCheckboxElement(event.target),
      isSelect,
      selectedValue
    };
  };

  setFields = (event: any, isClick: boolean, rowData: any): void => {
    const _rowData = rowData;
    if (!rowData) return;

    const isCurrentInsertRow = this.props.insertRowActive && this.isInsertRow(rowData);
    if (isCurrentInsertRow && !isClick) return;

    const { dataValue, dataType, element, columnIndex } = this.getColumnDataFromEvent(event);
    if (!dataValue) return;

    const dataSource = this.getDataSource();
    if (!dataSource) return;

    const selectedRow = rowData;
    let selectedValue = selectedRow[dataValue]?.toString();

    if (dataType === ValueType.Date && selectedValue) {
      selectedValue = moment(selectedValue).format("YYYY-MM-DD HH:mm:ss");
    }

    if (this.isBooleanElement(event.target) || this.isCheckboxElement(event.target)) {
      selectedValue = selectedValue === "true";
    }

    const {
      value: currentValue,
      isDate,
      isBoolean,
      isSelect,
      selectedValue: selectboxSelectedValue
    } = this.getColumnValue(event, dataType, element);

    if (isSelect && selectboxSelectedValue) {
      selectedValue = selectboxSelectedValue;
    }

    if (currentValue === selectedValue) {
      return;
    }

    let inputValue = currentValue;
    if (!isDate && !isBoolean && dataType !== ValueType.Number) {
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        event.target instanceof HTMLSelectElement
      ) {
        inputValue = event.target.value;
      } else {
        inputValue = currentValue;
      }
    }

    const updatedRow = {
      ...selectedRow,
      [dataValue]: isSelect
        ? selectedValue
        : isDate || isBoolean
          ? currentValue
          : dataType === ValueType.Number
            ? parseFloat(currentValue)
            : inputValue
    };

    for (let i = 0; i < dataSource.length; i++) {
      if (dataSource[i].id === updatedRow.id) {
        dataSource[i] = updatedRow;
        break;
      }
    }

    const isInsertRow = isCurrentInsertRow || (this.props.insertRowActive && this.isInsertRow(updatedRow));
    const formValues = this.getFormValues(updatedRow, isInsertRow);
    this.props.form?.setFieldsValue(formValues);

    if (
      ((isBoolean && element.hasAttribute("columnIndex")) || (isDate && currentValue !== selectedValue) || isSelect) &&
      !isInsertRow
    ) {
      let rowData = this.getRowDataFromElement(event.target as HTMLElement);
      if (isSelect || isBoolean) {
        rowData = _rowData;
      }
      this.handleOnRowEditFinished(rowData);
    }
  };

  handleCellBlur = (event: React.FocusEvent, rowIndex: number, columnIndex: number): void => {
    if (!this.props.editableAlwaysActive) {
      return;
    }

    const currentTarget = event.currentTarget as HTMLElement;
    const rowElement = this.findRowElement(currentTarget);
    if (!rowElement) return;

    const rowKey = rowElement.getAttribute("data-row-key");
    if (!rowKey) return;

    const dataSource = this.getDataSource();
    if (!dataSource) return;

    const rowData = BaseTable.findRowByKey(dataSource, rowKey, this.props.rowKey?.toString() || "id");
    if (!rowData) return;

    const isInsertRow = this.props.insertRowActive && this.isInsertRow(rowData);

    const relatedTarget = event.relatedTarget as HTMLElement;
    if (relatedTarget) {
      const clickedRowElement = this.findRowElement(relatedTarget);
      if (clickedRowElement) {
        const clickedRowKey = clickedRowElement.getAttribute("data-row-key");
        if (clickedRowKey) {
          const clickedRowData = BaseTable.findRowByKey(
            dataSource,
            clickedRowKey,
            this.props.rowKey?.toString() || "id"
          );
          if (clickedRowData) {
            const clickedInsertRow = this.props.insertRowActive && this.isInsertRow(clickedRowData);
            if (isInsertRow && clickedInsertRow) {
              return;
            }
          }
        }
      }
    }

    const target = event.target as HTMLElement;
    const dataValue = currentTarget.getAttribute("datavalue");
    const dataType = currentTarget.getAttribute("datatype");

    if (!dataValue) return;

    let selectedColumnValue = rowData[dataValue]?.toString();
    let currentColumnValue = "";

    if (target.classList.contains("ant-select-selection-search-input")) {
      const activeDescendantId = target.getAttribute("aria-activedescendant");
      currentColumnValue = document.getElementById(activeDescendantId)?.innerText || "";
    } else {
      if (
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target instanceof HTMLSelectElement
      ) {
        currentColumnValue = target.value?.toString() || "";
      } else {
        const inputElement = target.querySelector("input, textarea, select");
        if (
          inputElement instanceof HTMLInputElement ||
          inputElement instanceof HTMLTextAreaElement ||
          inputElement instanceof HTMLSelectElement
        ) {
          currentColumnValue = inputElement.value?.toString() || "";
        }
      }
      if (dataType === ValueType.Number) {
        currentColumnValue = BaseTable.parseLocalizedNumberString(currentColumnValue);
      } else {
        currentColumnValue = currentColumnValue.replace(/[,]/g, "");
      }
    }

    if (currentColumnValue === "Invalid date") {
      return;
    }

    let formattedDate = "";
    if (dataType === ValueType.Date) {
      currentColumnValue = moment(currentColumnValue, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
      formattedDate = moment(selectedColumnValue).format("YYYY-MM-DD HH:mm:ss");
    }

    if (currentColumnValue === selectedColumnValue || selectedColumnValue === "NaN") {
      return;
    }

    if (dataType === ValueType.Date && formattedDate) {
      if (selectedColumnValue !== formattedDate && formattedDate !== "Invalid date") {
        this.setFields(event, true, rowData);
        this.handleOnRowEditFinished(rowData);
      }
    } else {
      this.setFields(event, true, rowData);
      if (isInsertRow) {
        const updatedRowData = this.getCurrentFirstRowInputValues();
        this.setFields(event, true, updatedRowData);
        this.handleOnRowEditFinished(updatedRowData, true);
      } else {
        this.handleOnRowEditFinished(rowData);
      }
    }

    const selectedColumnIndexInput = this.getSelectedColumnIndexHiddenInput();
    if (selectedColumnIndexInput && columnIndex !== undefined) {
      selectedColumnIndexInput.value = columnIndex.toString();
    }
  };

  getCurrentFirstRowInputValues = (): any | null => {
    const dataSource = this.getDataSource();
    if (!dataSource || dataSource.length === 0) return null;

    const firstRowData = dataSource[0];
    if (!firstRowData) return null;

    const tableElement = document.querySelector(`.${this.getClassName().trim()}`);
    if (!tableElement) return firstRowData;

    const rowElement = tableElement.querySelector(`tr[data-row-key="${firstRowData.id}"]`);
    if (!rowElement) return firstRowData;

    const result = {};

    Object.keys(firstRowData).forEach((fieldName) => {
      result[fieldName] = firstRowData[fieldName];
    });

    const inputElements = rowElement.querySelectorAll("input, textarea, select");
    inputElements.forEach((inputElement) => {
      const columnElement = this.findAttributeInTree(inputElement as HTMLElement, "datavalue");
      if (columnElement) {
        const fieldName = columnElement;
        let value = (inputElement as HTMLInputElement).value;

        if (inputElement.getAttribute("type") === "checkbox") {
          value = (inputElement as HTMLInputElement).checked.toString();
        } else if (inputElement.getAttribute("datatype") === ValueType.Number) {
          const numericValue = BaseTable.parseLocalizedNumberString(value);
          value = parseFloat(numericValue).toString();
        }

        if (value === "") {
          value = undefined;
        }

        if (inputElement.getAttribute("datatype") !== ValueType.Number) {
          value = value?.replace?.(/[,]/g, "");
        }

        result[fieldName] = value;
      }
    });

    const selectElements = rowElement.querySelectorAll(".ant-select");
    selectElements.forEach((selectElement) => {
      const columnElement = this.findAttributeInTree(selectElement as HTMLElement, "datavalue");
      if (columnElement) {
        const fieldName = columnElement;

        const hiddenInput = selectElement.querySelector(".ant-select-selection-search-input");
        if (hiddenInput) {
          const ariaControls = (hiddenInput as HTMLElement).getAttribute("aria-controls");
          if (ariaControls) {
            const selectedOption = document.querySelector(`.ant-select-item-option-selected[data-value]`);
            if (selectedOption) {
              const value = selectedOption.getAttribute("data-value");

              if (selectElement.getAttribute("datatype") === ValueType.Number && !isNaN(Number(value))) {
                result[fieldName] = Number(value);
              } else {
                result[fieldName] = value;
              }
              return;
            }
          }

          const dataValue = selectElement.getAttribute("data-value");
          if (dataValue) {
            result[fieldName] = dataValue;
            return;
          }

          if (this.props.form) {
            const formKey = `Table_${this.props.id}_${fieldName}`;
            const formValue = this.props.form.getFieldValue(formKey);
            if (formValue !== undefined) {
              result[fieldName] = formValue;
              return;
            }
          }
        }

        const selectedValueElement = selectElement.querySelector(".ant-select-selection-item");
        if (selectedValueElement) {
          const valueAttribute =
            selectElement.getAttribute("data-selection-value") ||
            selectedValueElement.getAttribute("data-value") ||
            selectedValueElement.getAttribute("value");

          const displayValue = selectedValueElement.textContent;
          const value = valueAttribute || displayValue;

          if (selectElement.getAttribute("datatype") === ValueType.Number && !isNaN(Number(value))) {
            result[fieldName] = Number(value);
          } else {
            result[fieldName] = value;
          }
        }
      }
    });

    const switchElements = rowElement.querySelectorAll(".ant-switch");
    switchElements.forEach((switchElement) => {
      const columnElement = this.findAttributeInTree(switchElement as HTMLElement, "datavalue");
      if (columnElement) {
        const fieldName = columnElement;
        const isChecked = switchElement.classList.contains("ant-switch-checked");
        result[fieldName] = isChecked;
      }
    });

    const checkboxElements = rowElement.querySelectorAll(".ant-checkbox-wrapper");
    checkboxElements.forEach((checkboxElement) => {
      const columnElement = this.findAttributeInTree(checkboxElement as HTMLElement, "datavalue");
      if (columnElement) {
        const fieldName = columnElement;
        const isChecked = checkboxElement.querySelector(".ant-checkbox-checked") !== null;
        result[fieldName] = isChecked;
      }
    });

    return result;
  };

  getRowComponent = () => {
    const childList = React.Children.toArray(this.props.children);
    return childList[1];
  };

  getPagination = () => {
    if (this.props.pagination && this.props.pagination === true) {
      const paginationProps = {
        pageSize: this.state.pageSize,
        showSizeChanger: this.props.showSizeChanger,
        pageSizeOptions: this.getPageSizeOptions(),
        onShowSizeChange: (current: number, size: number) => this.onPageSizeChange(current, size),
        onChange: (current: number) => this.setState({ current } as any)
      };
      return paginationProps;
    }
    return false;
  };

  onPageSizeChange = (current: number, size: number) => {
    this.setState({ pageSize: size, current } as any);
  };

  getPageSizeOptions = () => {
    const options = this.props.options;
    if (options && options.length > 0) {
      const mappedOptions: number[] = [];
      options.forEach((option: any) => {
        const value = option.text?.trim() ?? option[this.props.datavaluefield];
        if (!isNaN(value) && value !== null && value !== undefined && value !== "") {
          mappedOptions.push(parseInt(value, 10));
        }
      });
      mappedOptions?.sort((a, b) => a - b);
      if (mappedOptions.length > 0) return mappedOptions;
    }

    return BaseTable.DEFAULT_PAGE_SIZE_OPTIONS;
  };

  shouldComponentUpdate = (nextProps: any, nextState: any) => {
    if (window.kuika?.isDesignTime) {
      // In design time, allow updates if children changed (e.g., dragging elements into columns)
      // Compare children reference - React creates new elements when structure changes
      if (nextProps.children !== this.props.children) {
        return true;
      }
      return false;
    }
    if (nextProps.mode === "carousel") {
      if (this.props.dataSource === undefined || this.props.dataSource !== nextProps.dataSource) return true;
      return false;
    }
    if (nextProps.mode === "google-maps") {
      if (this.props.dataSource === undefined || this.props.dataSource !== nextProps.dataSource) {
        if (_.isEqual(this.props.dataSource, nextProps.dataSource) === false) {
          return true;
        }
      }
      if (this.props.waypoints === undefined || this.props.waypoints !== nextProps.waypoints) {
        if (_.isEqual(this.props.waypoints, nextProps.waypoints) === false) {
          return true;
        }
      }
      if (this.refreshGoogleMapsBodyWrapper && this.state.value !== nextState.value) {
        const { value } = nextState;
        if (value != undefined && value.latitude != undefined && value.longitude != undefined) {
          if (this.props.autoCenter) {
            this.refreshGoogleMapsBodyWrapper({
              value: nextState.value,
              latitude: value.latitude,
              longitude: value.longitude
            });
          } else {
            this.refreshGoogleMapsBodyWrapper({ value: nextState.value });
          }
        }

        this.refreshGoogleMapsBodyWrapper({ value: nextState.value });
      }
      return false;
    }
    return !shallowequal(nextProps, this.props) || !shallowequal(nextState, this.state);
  };

  getRowProps = () => {
    const result: any = {};
    if (this.props.mode === "gallery") {
      result.desktopColumnsCount = (this.props as GalleryItemProps).desktopColumnsCount;
      result.tabletColumnsCount = (this.props as GalleryItemProps).tabletColumnsCount;
      result.phoneColumnsCount = (this.props as GalleryItemProps).phoneColumnsCount;
    } else if (this.props.mode === "google-maps") {
      result.value = this.state.value;
      result.map = this.state.map;
      result.maps = this.state.maps;
      result.isDataMarkerSelected = this.state.isDataMarkerSelected;
    }
    return result;
  };

  convertToCoordsFieldsFromLatField = (record: any): number | undefined => {
    if (this.props.dataLatField === undefined) return undefined;
    if (this.props.dataLatField !== undefined && record[toCamelCase(this.props.dataLatField)] !== undefined) {
      const latitude = parseFloat(record[toCamelCase(this.props.dataLatField)]);
      return latitude;
    }
  };

  convertToCoordsFieldsFromLngField = (record: any): number | undefined => {
    if (this.props.dataLngField === undefined) return undefined;
    if (this.props.dataLngField !== undefined && record[toCamelCase(this.props.dataLngField)] !== undefined) {
      const longitude = parseFloat(record[toCamelCase(this.props.dataLngField)]);
      return longitude;
    }
  };

  getRowLat = (rowData: any) => {
    const latitude = this.convertToCoordsFieldsFromLatField(rowData);
    return latitude;
  };

  getRowLng = (rowData: any) => {
    const longitude = this.convertToCoordsFieldsFromLngField(rowData);
    return longitude;
  };

  resetEditableRow = () => {
    if (this.state.activeEditableRowIndex != -1 && (this.props.onRowEditFinished || this.props.onInsertRowFinished)) {
      this.handleOnRowEditFinished();
    }
  };

  getDataSource = () => {
    const isDesignTime = window.kuika?.isDesignTime;
    if (this.props.insertRowActive && this.props.dataSource && !isDesignTime) {
      const rowKey = this.props.rowKey?.toString()?.toLowerCase() || "id";
      let mockDataSource = {
        [rowKey]: this.props.onInsertRowFinished ? undefined : this.randomGuid
      };

      let children = this.props.children[1].props.children;
      if (children?.length > 0) {
        children.forEach((element) => {
          if (
            element &&
            element.props &&
            element.props.children &&
            element.props.children[0] &&
            element.props.children[0].props &&
            element.props.children[0].props.value
          ) {
            var key = element.props.children[0].props.value as string;
            if (key) {
              key = key.replace("[datafield:", "").replace("]", "");
              if (key !== rowKey) {
                mockDataSource[key] = undefined;
              }
            }
          }
        });
      }
      if (this.props.insertRowPosition === "bottom") {
        let dataSource = this.props.dataSource;
        let newDataSource = [];
        if (this.props.pagination === true) {
          dataSource.forEach((element, index) => {
            newDataSource.push(element);
            if (index % 8 === 0 && index !== 0) {
              newDataSource.push(mockDataSource);
            } else if (index === dataSource.length - 1) {
              newDataSource.push(mockDataSource);
            }
          });
        } else {
          newDataSource = [...dataSource, mockDataSource];
        }
        return newDataSource;
      }
      return [mockDataSource, ...this.props.dataSource];
    }

    if (typeof this.props.dataSource === "string") {
      const rowKey = this.props.rowKey?.toString()?.toLowerCase() || "id";
      let mockDataSource = {
        [rowKey]: this.props.onInsertRowFinished ? undefined : this.randomGuid
      };
      return [mockDataSource];
    }
    if (window.kuika.dashboardState === 17) return this.props.dataSource.slice(0, 2);
    return this.props.dataSource;
  };

  getTableStyles = () => {
    if (window.kuika.dashboardState === 17) {
      const { borderWidth, borderColor, borderLeftWidth, borderRightWidth, borderTopWidth, borderBottomWidth } =
        this.props.style;
      if (borderWidth || borderColor || borderLeftWidth || borderRightWidth || borderTopWidth || borderBottomWidth) {
        this.props.style.borderStyle = "solid";
      }
    }

    if (this.props.mode === "carousel") {
      const { width, height, maxWidth, maxHeight } = this.props.style;
      delete this.props.style?.width;
      delete this.props.style?.height;
      delete this.props.style?.maxWidth;
      delete this.props.style?.maxHeight;
      return {
        width,
        height,
        maxWidth,
        maxHeight
      };
    }
  };

  setStartingIndex = (index: number) => {
    const totalSlides = this.props.dataSource?.length || 0;
    const validIndex = index < totalSlides ? index : index % totalSlides;
    if (this.props.mode === "carousel") {
      this.setState({ carouselStartingIndex: validIndex } as any);
      this.forceUpdate();
    }
  };

  static normalizeTurkishString = (str: any): string => {
    if (!str || typeof str !== "string") return "";
    const lowerCased = str.toLocaleLowerCase("tr-TR");
    const normalized = lowerCased
      .replace(/ı/g, "i")
      .replace(/ğ/g, "g")
      .replace(/ü/g, "u")
      .replace(/ş/g, "s")
      .replace(/ö/g, "o")
      .replace(/ç/g, "c");
    return normalized;
  };

  setSearchText = (searchText: string) => {
    this.setState({ searchText } as any);
  };

  setColumnSearchTexts = (key: string, value: string) => {
    const columnSearchTexts: { [key: string]: string } = {
      ...this.state.columnSearchTexts
    };
    columnSearchTexts[key] = value;
    this.setState({ columnSearchTexts } as any);
  };

  onHeaderSearchBlur = () => {
    if (this.props.onConfigChange) this.props.onConfigChange();
    this.requestSyncColumnWidths();
  };

  filterListBySearchText(rows: any, searchText: any) {
    const searchNormalized = BaseTable.normalizeTurkishString(searchText?.toString());
    let filteredList = rows;
    if (searchText && searchText !== "") {
      const visibleColumns = this.state.columns
        ?.filter(
          (c) =>
            c.visibility !== "hidden" &&
            !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === c.id.toLowerCase())
        )
        ?.map((c: any) => c.dataValue)
        ?.filter(Boolean);

      filteredList = rows.filter((item: any) => {
        for (let key in item) {
          if (!visibleColumns?.some((col) => col.toLowerCase() === key.toLowerCase())) continue;

          const itemNormalized = BaseTable.normalizeTurkishString(item[key]?.toString());
          if (
            (typeof item[key] === "string" || typeof item[key] === "number") &&
            itemNormalized?.includes(searchNormalized)
          ) {
            return true;
          }
        }
        return false;
      });
    }

    const columnSearchTexts = this.state.columnSearchTexts;
    if (columnSearchTexts) {
      for (let key in columnSearchTexts) {
        const columnSearchText: any = columnSearchTexts[key];
        if (columnSearchText || columnSearchText === false) {
          const filteredListByColumnSearchText = filteredList.filter((item: any) => {
            const cellValue = item[key];

            const columnMeta = this.state.columns?.find(
              (c: any) => c?.dataValue && c.dataValue.toString().toLowerCase() === key.toString().toLowerCase()
            );
            const dateSearchFormat = (columnMeta as any)?.dateSearchFormat;
            const columnType = (columnMeta as any)?.dataType ?? ValueType.String;

            const searchDate = BaseTable.parseDateWithFormat(columnSearchText, dateSearchFormat, columnType);
            const isSearchDate = !!columnSearchText && searchDate.isValid();
            const isCellDate =
              BaseTable.getValueType(cellValue) === ValueType.Date ||
              (!!dateSearchFormat && typeof cellValue === "string");
            if (isSearchDate || isCellDate) {
              const cellDate = BaseTable.parseDateWithFormat(cellValue, dateSearchFormat, columnType);
              if (cellDate.isValid() && isSearchDate) {
                const comparisonUnit = BaseTable.getDateComparisonUnit(dateSearchFormat);
                if (cellDate.isSame(searchDate, comparisonUnit)) {
                  return true;
                }
                const normalizedSearch = BaseTable.normalizeTurkishString(columnSearchText.toString());
                const formattedCellDate = dateSearchFormat
                  ? cellDate.format(dateSearchFormat)
                  : cellDate.format("DD.MM.YYYY");
                const normalizedFormattedDate = BaseTable.normalizeTurkishString(formattedCellDate);
                if (normalizedFormattedDate.includes(normalizedSearch)) {
                  return true;
                }
              }
            }

            if (typeof cellValue === "string" || typeof cellValue === "number") {
              const itemNormalized = BaseTable.normalizeTurkishString(cellValue.toString());
              const columnSearchTextNormalized = BaseTable.normalizeTurkishString(columnSearchText.toString());
              if (itemNormalized.includes(columnSearchTextNormalized)) {
                return true;
              }
            }
            if (typeof item[key] === "boolean") {
              if (item[key] === true && (columnSearchText === "true" || columnSearchText === true)) {
                return true;
              }
              if (item[key] === false && (columnSearchText === "false" || columnSearchText === false)) {
                return true;
              }
            }
            return false;
          });
          filteredList = filteredListByColumnSearchText;
        }
      }
    }

    return filteredList;
  }

  handleCheckboxChange = (checkedValues) => {
    const { columns } = this.state;

    const allVisibleColumns = columns.filter((c) => c.visibility !== "hidden").map((c) => c.id);
    const newHiddenColumnList: any = allVisibleColumns.filter((id) => !checkedValues.includes(id));

    this.setState({ hiddenColumnList: newHiddenColumnList });
  };

  handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const columns: any = this.reorder(this.state.columns, result.source.index, result.destination.index);

    const columnOrder = columns.map((col: any) => col.id);

    if (this.state.columnGroups?.length > 0) {
      const groupColumnIds = this.state.columnGroups.map((group) => group.children.map((child) => child.id)).flat();

      const allColumnIds = [...columnOrder];
      groupColumnIds.forEach((id) => {
        if (!allColumnIds.includes(id)) {
          allColumnIds.push(id);
        }
      });

      this.setState(
        {
          columns,
          columnOrder: allColumnIds as any
        },
        () => {
          this.handleColumnOrderChange(allColumnIds);
          this.requestSyncColumnWidths();
        }
      );
    } else {
      this.setState(
        {
          columns,
          columnOrder
        },
        () => {
          this.handleColumnOrderChange(columnOrder);
          this.requestSyncColumnWidths();
        }
      );
    }
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  setResizingColumnIndex = (index: any, startX: number) => {
    this.resizingColumnIndexRef = React.createRef();
    (this.resizingColumnIndexRef as any).current = index;
    this.startX = startX;

    const table = document.getElementById(this.props.id);
    if (table) {
      table.classList.add("resizing-active");

      table.style.setProperty("--resizing-column-index", index.toString());

      const firstColumnCell: any = table.querySelector(`[columnindex="${index}"]`);
      if (firstColumnCell) {
        this.initialWidth = firstColumnCell.offsetWidth;

        const allResizeHandles = table.querySelectorAll(`[columnindex="${index}"] .resizeHandle`);
        allResizeHandles.forEach((resizeHandle: HTMLElement) => {
          resizeHandle.classList.add("resizing");
        });

        const allColumnCells = table.querySelectorAll(`[columnindex="${index}"]`);
        allColumnCells.forEach((cell: HTMLElement) => {
          cell.classList.add("resizing-column");
        });
      }
    }

    this.setState({ resizingColumnIndex: index });

    window.addEventListener("mousemove", this.resizeListener);

    window.addEventListener("mouseup", this.handleResizeEnd, { once: true });
  };

  resizeListener = (e: any) => {
    if (
      this.resizingColumnIndexRef.current !== undefined &&
      this.startX !== undefined &&
      this.initialWidth !== undefined
    ) {
      const table = document.getElementById(this.props.id);
      if (table) {
        const deltaX = e.clientX - this.startX;
        const newColumnWidth = this.initialWidth + deltaX;
        if (newColumnWidth > 50) {
          const allColumnCells = table.querySelectorAll(`[columnindex="${this.resizingColumnIndexRef.current}"]`);
          allColumnCells.forEach((cell: HTMLElement) => {
            cell.style.width = `${newColumnWidth}px`;
            cell.style.minWidth = `${newColumnWidth}px`;
            cell.style.maxWidth = `${newColumnWidth}px`;

            if (!cell.classList.contains("resizing-column")) {
              cell.classList.add("resizing-column");
            }
          });

          this.setState({
            columnWidths: {
              ...this.state.columnWidths,
              [this.resizingColumnIndexRef.current]: newColumnWidth
            }
          });
        }
      }
    }
  };

  handleResizeEnd = () => {
    const table = document.getElementById(this.props.id);
    if (table && this.resizingColumnIndexRef.current !== undefined) {
      table.classList.remove("resizing-active");

      table.style.removeProperty("--resizing-column-index");

      const allResizeHandles = table.querySelectorAll(
        `[columnindex="${this.resizingColumnIndexRef.current}"] .resizeHandle`
      );
      allResizeHandles.forEach((resizeHandle: HTMLElement) => {
        resizeHandle.classList.remove("resizing");
      });

      const allColumnCells = table.querySelectorAll(`[columnindex="${this.resizingColumnIndexRef.current}"]`);
      allColumnCells.forEach((cell: HTMLElement) => {
        cell.classList.remove("resizing-column");
        cell.style.removeProperty("width");
        cell.style.removeProperty("min-width");
        cell.style.removeProperty("max-width");
      });
    }

    window.removeEventListener("mousemove", this.resizeListener);
    this.setState({ resizingColumnIndex: undefined });
    if (this.props.onConfigChange) this.props.onConfigChange();
    this.requestSyncColumnWidths();
  };

  handleMouseUp = () => {
    if (this.state.resizingColumnIndex !== undefined) {
      const table = document.getElementById(this.props.id);
      if (table && this.resizingColumnIndexRef.current !== undefined) {
        table.classList.remove("resizing-active");

        table.style.removeProperty("--resizing-column-index");

        const allResizeHandles = table.querySelectorAll(
          `[columnindex="${this.resizingColumnIndexRef.current}"] .resizeHandle`
        );
        allResizeHandles.forEach((resizeHandle: HTMLElement) => {
          resizeHandle.classList.remove("resizing");
        });

        const allColumnCells = table.querySelectorAll(`[columnindex="${this.resizingColumnIndexRef.current}"]`);
        allColumnCells.forEach((cell: HTMLElement) => {
          cell.classList.remove("resizing-column");
          cell.style.removeProperty("width");
          cell.style.removeProperty("min-width");
          cell.style.removeProperty("max-width");
        });
      }

      window.removeEventListener("mousemove", this.resizeListener);
      this.setState({ resizingColumnIndex: undefined });
      if (this.props.onConfigChange) this.props.onConfigChange();
      this.requestSyncColumnWidths();
    }
  };

  handleColumnOrderChange = (newOrder) => {
    this.setState({ columnOrder: newOrder });
  };

  handleTableChange = (pagination, filters, sorter) => {
    if (sorter) {
      const sorterOptions = {
        field: sorter.column?.dataValue,
        order: sorter.order,
        columnId: sorter.column?.id
      };
      this.setState({ sorterOptions }, () => {
        this.requestSyncColumnWidths();
      });
    } else {
      this.setState({ sorterOptions: {} }, () => {
        this.requestSyncColumnWidths();
      });
    }
    if (filters) {
      Object.values(filters).forEach((filter: any) => {
        if (filter && filter[0] && filter[0].value) {
          const columns = this.state.columns;
          const column: any = columns.find((c) => c.id === filter[0].columnId);
          if (column) {
            filter[0].dataValue = column.dataValue;
            filter[0].columnId = column.id;

            filter[0].logicalOperator = filter[0].logicalOperator || "AND";

            BaseTable.normalizeFilterValue(filter[0], "type", StringFilterTypes.Contains);
            BaseTable.normalizeFilterValue(filter[0], "value");
            BaseTable.normalizeFilterValue(filter[0], "value2");

            if (filter[0].secondType) {
              BaseTable.normalizeFilterValue(filter[0], "secondType", StringFilterTypes.Contains);
              BaseTable.normalizeFilterValue(filter[0], "secondValue");
              BaseTable.normalizeFilterValue(filter[0], "secondValue2");
            }
          }
        }
      });
      this.setState({ filteringOptions: filters }, () => {
        this.requestSyncColumnWidths();
      });
    } else {
      this.setState({ filteringOptions: {} }, () => {
        this.requestSyncColumnWidths();
      });
    }
    if (this.props.onConfigChange) this.props.onConfigChange();
  };

  static normalizeFilterValue = (filter: any, field: string, defaultValue?: any) => {
    if (filter[field] === "") {
      filter[field] = undefined;
    }

    if (filter[field] === undefined && defaultValue !== undefined) {
      filter[field] = defaultValue;
    }
  };

  parseNumericValue = (value: any): number => {
    const num = Number(value);
    if (!Number.isNaN(num)) {
      return num;
    }
    if (typeof value === "string") {
      const normalized = value.replace(/\./g, "").replace(",", ".");
      return Number(normalized);
    }
    return num;
  };

  getFormattedValue(value: any, formatter: string) {
    if (formatter && value && value?.toString()?.trim() !== "") {
      const numericValue = this.parseNumericValue(value);
      switch (formatter) {
        case "money":
          if (Number.isNaN(numericValue)) {
            return "0.00";
          }

          return getCachedNumberFormat("tr-TR", {
            style: "currency",
            currency: "TRY",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
            .format(numericValue)
            .replace("₺", "");

        case "money-var-1":
          if (Number.isNaN(numericValue)) {
            return "0.00";
          }

          return getCachedNumberFormat("tr-TR", {
            style: "currency",
            currency: "TRY",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          })
            .format(numericValue)
            .replace("₺", "");

        case "money-tl":
          if (Number.isNaN(numericValue)) {
            return "₺0.00";
          }

          return getCachedNumberFormat("tr-TR", {
            style: "currency",
            currency: "TRY",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(numericValue);

        case "money-tl-var-1":
          if (Number.isNaN(numericValue)) {
            return "₺0";
          }

          return getCachedNumberFormat("tr-TR", {
            style: "currency",
            currency: "TRY",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(numericValue);

        case "money-4-decimal":
          if (Number.isNaN(numericValue)) {
            return "0.0000";
          }

          return getCachedNumberFormat("tr-TR", {
            style: "currency",
            currency: "TRY",
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          })
            .format(numericValue)
            .replace("₺", "");

        case "money-eur":
          if (Number.isNaN(numericValue)) {
            return "€0.00";
          }
          return `€${getCachedNumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(numericValue)}`;

        case "money-usd":
          if (Number.isNaN(numericValue)) {
            return "$0.00";
          }
          return getCachedNumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(numericValue);

        case "money-eur-var-1":
          if (Number.isNaN(numericValue)) {
            return "€0";
          }
          return `€${getCachedNumberFormat("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(numericValue)}`;

        case "money-usd-var-1":
          if (Number.isNaN(numericValue)) {
            return "$0";
          }
          return getCachedNumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(numericValue);

        case "money-usd-4-decimal":
          if (Number.isNaN(numericValue)) {
            return "$0.0000";
          }
          return getCachedNumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          }).format(numericValue);

        case "money-eur-4-decimal":
          if (Number.isNaN(numericValue)) {
            return "€0.0000";
          }
          return `€${getCachedNumberFormat("en-US", {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          }).format(numericValue)}`;

        case "money-tl-4-decimal":
          if (Number.isNaN(numericValue)) {
            return "₺0.0000";
          }
          return getCachedNumberFormat("tr-TR", {
            style: "currency",
            currency: "TRY",
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          }).format(numericValue);

        case "percent":
          return `${value}%`;

        case "fractional-2":
          return isNaN(numericValue) ? value : numericValue.toFixed(2);

        case "fractional-5":
          return isNaN(numericValue) ? value : numericValue.toFixed(5);

        case "round":
          return isNaN(numericValue) ? value : String(Math.round(numericValue));

        default:
          return value;
      }
    }
    return value?.toString();
  }

  getFilteredAndSortedDataSource = () => {
    let filteredList =
      this.props.searchable || this.props.globalSearch || this.state.searchText
        ? this.filterListBySearchText(this.getDataSource(), this.state.searchText)
        : this.getDataSource();

    if (this.state.filteringOptions) {
      const andFilters: any[] = [];
      const orFilters: any[] = [];

      Object.entries(this.state.filteringOptions).forEach(([c, filters]: any) => {
        if (filters && filters.length > 0) {
          const { value, value2, type, columnId, logicalOperator, secondValue, secondValue2, secondType } = filters[0];

          const column = this.state.columns.find((col) => col.id === columnId);
          if (column) {
            const { dataValue, dataType }: any = column;

            const filterInfo = {
              filterCriteria: {
                value: value !== undefined ? value : null,
                value2: value2 !== undefined ? value2 : null,
                type: type || StringFilterTypes.Contains,
                logicalOperator,
                secondType,
                secondValue: secondValue !== undefined ? secondValue : null,
                secondValue2: secondValue2 !== undefined ? secondValue2 : null,
                dateSearchFormat: (column as any).dateSearchFormat
              },
              dataValue,
              dataType
            };

            if (logicalOperator === "OR") {
              orFilters.push(filterInfo);
            } else {
              andFilters.push(filterInfo);
            }
          }
        }
      });

      if (andFilters.length > 0) {
        filteredList = filteredList.filter((record) => {
          return andFilters.every((filter) => {
            return BaseTable.applyFilter(filter.filterCriteria, record, filter.dataValue, filter.dataType);
          });
        });
      }

      if (orFilters.length > 0) {
        filteredList = filteredList.filter((record) => {
          return orFilters.some((filter) => {
            return BaseTable.applyFilter(filter.filterCriteria, record, filter.dataValue, filter.dataType);
          });
        });
      }
    }

    if (this.state.sorterOptions && this.state.sorterOptions.field) {
      const { field, order } = this.state.sorterOptions;
      filteredList.sort((a, b) => {
        const result = BaseTable.compare(field, a, b, this.props.rowKey?.toString()?.toLowerCase());
        return order === "ascend" ? result : -result;
      });
    }

    return filteredList;
  };

  renderSummary = () => {
    const isDesignTime = window.kuika?.isDesignTime;

    const hasFooter = this.state.columns?.some(
      (column: any) => column.footerOptions !== FooterOptions.None && column.footerOptions
    );
    if (!hasFooter) return <></>;

    const calculateTotals = (column) => {
      const { footerOptions, dataType, dataValue, footerFormatter } = column;
      if (footerOptions === FooterOptions.None) return "";

      let filteredList = this.getFilteredAndSortedDataSource();

      const columnData = filteredList?.map((row) => row[dataValue]) || [];

      if (footerOptions === FooterOptions.Count) {
        return this.getFormattedValue(columnData.length, footerFormatter);
      }

      const numericData = columnData.map((val) => (val != null ? parseFloat(val) : NaN)).filter((val) => !isNaN(val));

      if (dataType !== ValueType.Number && numericData.length === 0) return "";

      switch (footerOptions) {
        case FooterOptions.Sum:
          return this.getFormattedValue(
            numericData.reduce((acc, val) => acc + val, 0),
            footerFormatter
          );
        case FooterOptions.Average:
          return this.getFormattedValue(
            numericData.length ? (numericData.reduce((acc, val) => acc + val, 0) / numericData.length).toFixed(2) : 0,
            footerFormatter
          );
        case FooterOptions.Min:
          return this.getFormattedValue(numericData.length ? Math.min(...numericData) : 0, footerFormatter);
        case FooterOptions.Max:
          return this.getFormattedValue(numericData.length ? Math.max(...numericData) : 0, footerFormatter);
        default:
          return "";
      }
    };

    const visibleColumns = this.state.columns?.filter(
      (col: any) =>
        col.visibility !== "hidden" &&
        !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === col.id.toLowerCase())
    );
    const totals = visibleColumns?.map(calculateTotals);

    const convertFontWeightToNumber = (fontWeight: string): number => {
      const fontWeightMap = {
        Thin: 100,
        "Extra-Light": 200,
        Light: 300,
        Regular: 400,
        Medium: 500,
        "Semi-Bold": 600,
        Bold: 700,
        "Extra-Bold": 800,
        Black: 900
      };
      return fontWeightMap[fontWeight] || 400;
    };

    const renderSummaryCell = (column, index) => {
      const {
        footerOptions,
        footerFormatter,
        dataType,
        style,
        footerOptionLabel,
        footerFontSize,
        footerFontColor,
        footerTextAlign,
        footerFontWeight
      } = column;
      const hasFooterCalculation =
        dataType === ValueType.Number ||
        isDesignTime ||
        footerOptions === FooterOptions.Count ||
        (footerOptions && footerOptions !== FooterOptions.None && totals[index] !== "");

      if (!hasFooterCalculation) return <Table.Summary.Cell key={index} index={index} />;
      const designTimeValue = footerOptions !== FooterOptions.None ? this.getFormattedValue("20", footerFormatter) : "";
      const content = (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent:
              footerTextAlign === "middle"
                ? "center"
                : footerTextAlign === "left"
                  ? "flex-start"
                  : footerTextAlign === "right"
                    ? "flex-end"
                    : style?.textAlign === "-webkit-center"
                      ? "center"
                      : style?.textAlign === "-webkit-left"
                        ? "flex-start"
                        : style?.textAlign === "-webkit-right"
                          ? "flex-end"
                          : ""
          }}
        >
          {footerOptionLabel && (
            <span
              style={{
                fontSize: footerFontSize,
                color: footerFontColor,
                fontWeight: footerFontWeight ? convertFontWeightToNumber(footerFontWeight) : undefined
              }}
            >
              {footerOptionLabel}
            </span>
          )}
          <span
            style={{
              fontSize: footerFontSize,
              color: footerFontColor,
              fontWeight: footerFontWeight ? convertFontWeightToNumber(footerFontWeight) : undefined,
              marginLeft:
                footerTextAlign !== null && footerTextAlign !== undefined
                  ? footerTextAlign === "left"
                    ? footerOptionLabel
                      ? "8px"
                      : "0px"
                    : footerTextAlign === "right"
                      ? "auto"
                      : footerTextAlign === "middle"
                        ? footerOptionLabel
                          ? "8px"
                          : "0px"
                        : ""
                  : style?.textAlign === "-webkit-left"
                    ? footerOptionLabel
                      ? "8px"
                      : "0px"
                    : style?.textAlign === "-webkit-right"
                      ? "auto"
                      : style?.textAlign === "-webkit-center"
                        ? footerOptionLabel
                          ? "8px"
                          : "0px"
                        : ""
            }}
          >
            {isDesignTime ? designTimeValue : totals[index] || ""}
          </span>
        </div>
      );

      return (
        <Table.Summary.Cell
          key={index}
          index={index}
          align={
            footerTextAlign !== null && footerTextAlign !== undefined
              ? footerTextAlign === "middle"
                ? "center"
                : footerTextAlign
              : style?.textAlign === "-webkit-center"
                ? "center"
                : style?.textAlign === "-webkit-left"
                  ? "left"
                  : style?.textAlign === "-webkit-right"
                    ? "right"
                    : "left"
          }
        >
          {content}
        </Table.Summary.Cell>
      );
    };
    return (
      <Table.Summary>
        <Table.Summary.Row>
          {this.props.multiSelect && <Table.Summary.Cell index={0} />}
          {visibleColumns?.map(renderSummaryCell)}
        </Table.Summary.Row>
      </Table.Summary>
    );
  };

  onExport = async () => {
    const ExcelJS = (await import("exceljs")).default;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    const colorToARGB = (color: string): string => {
      if (!color) return "";

      if (color.startsWith("#")) {
        const hex = color.replace("#", "");
        return hex.length === 6 ? `FF${hex}` : hex;
      }

      if (color.startsWith("rgb")) {
        const rgbMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
        if (rgbMatch) {
          const r = parseInt(rgbMatch[1]).toString(16).padStart(2, "0");
          const g = parseInt(rgbMatch[2]).toString(16).padStart(2, "0");
          const b = parseInt(rgbMatch[3]).toString(16).padStart(2, "0");
          const a = rgbMatch[4]
            ? Math.round(parseFloat(rgbMatch[4]) * 255)
                .toString(16)
                .padStart(2, "0")
            : "FF";
          return a + r + g + b;
        }
      }

      return color.replace("#", "");
    };

    const visibleColumns = this.state.columns?.filter(
      (column: any) =>
        column.excludeFromExport !== true &&
        !this.state.excludedFromExportList?.includes(column.id) &&
        column.visibility !== "hidden" &&
        !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === column.id.toLowerCase())
    );

    const sortedColumns = [
      ...visibleColumns.filter((col: any) => col.fixed === "left"),
      ...visibleColumns.filter((col: any) => !col.fixed),
      ...visibleColumns.filter((col: any) => col.fixed === "right")
    ];

    interface ColumnGroup {
      title: string;
      startIndex: number | null;
      endIndex: number | null;
      children: Array<TableColumnProps & CommonProps & { dataValue?: string; visibility?: string }>;
    }

    const columnGroups: { [key: string]: ColumnGroup } = {};
    this.state.columnGroups?.forEach((group) => {
      const visibleChildren = group.children.filter(
        (child: any) =>
          child.excludeFromExport !== true &&
          !this.state.excludedFromExportList?.includes(child.id) &&
          child.visibility !== "hidden" &&
          !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === child.id.toLowerCase())
      );

      if (visibleChildren.length > 0) {
        columnGroups[group.title] = {
          title: group.title,
          startIndex: null,
          endIndex: null,
          children: visibleChildren
        };
      }
    });

    for (const group of Object.values(columnGroups)) {
      for (const child of group.children) {
        if (!sortedColumns.some((col: any) => col.id === child.id)) {
          sortedColumns.push(child);
        }
      }
    }

    const columnDefinitions = sortedColumns.map(({ title }: any, colIndex: number) => ({
      header: title,
      key: `col${colIndex}`,
      width: 15
    }));

    worksheet.columns = columnDefinitions;

    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };

    sortedColumns.forEach(({ style }: any, colIndex: number) => {
      if (style?.backgroundColor) {
        const cell = headerRow.getCell(colIndex + 1);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: colorToARGB(style.backgroundColor) }
        };
      }
    });

    if (Object.keys(columnGroups).length > 0) {
      worksheet.spliceRows(1, 0, new Array(sortedColumns.length).fill(null));
      const groupHeaderRow = worksheet.getRow(1);

      let currentColIndex = 1;
      for (const col of sortedColumns) {
        for (const [groupTitle, group] of Object.entries(columnGroups)) {
          if (group.children.some((child: any) => child.id === col.id)) {
            if (group.startIndex === null) {
              group.startIndex = currentColIndex;
              group.endIndex = currentColIndex;
            } else {
              group.endIndex = currentColIndex;
            }
            break;
          }
        }
        currentColIndex++;
      }

      for (const [groupTitle, group] of Object.entries(columnGroups)) {
        if (group.startIndex !== null && group.endIndex !== null) {
          const startCell = groupHeaderRow.getCell(group.startIndex);
          startCell.value = groupTitle;

          if (group.endIndex > group.startIndex) {
            worksheet.mergeCells(1, group.startIndex, 1, group.endIndex);
          }
        }
      }

      groupHeaderRow.font = { bold: true };
      groupHeaderRow.alignment = { vertical: "middle", horizontal: "center" };

      const updatedHeaderRow = worksheet.getRow(2);
      updatedHeaderRow.font = { bold: true };
      updatedHeaderRow.alignment = { vertical: "middle", horizontal: "center" };

      sortedColumns.forEach(({ style }: any, colIndex: number) => {
        if (style?.backgroundColor) {
          const cell = updatedHeaderRow.getCell(colIndex + 1);
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: colorToARGB(style.backgroundColor) }
          };
        }
      });
    }

    const serializeValue = (value: any): string | number | boolean | Date | null => {
      if (value === null || value === undefined) {
        return null;
      }
      if (typeof value === "number") {
        return value;
      }
      if (typeof value === "boolean") {
        return value;
      }
      if (value instanceof Date) {
        return value;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          return value.map(serializeValue).join(", ");
        }
        try {
          return JSON.stringify(value);
        } catch {
          return String(value);
        }
      }
      return String(value);
    };

    let filteredList = this.getFilteredAndSortedDataSource();
    filteredList.forEach((record, recordIndex) => {
      const rowData = {};
      let hasMultipleLabels = false;

      sortedColumns.forEach((column: any, colIndex: number) => {
        const { dataValue, footerFormatter, title, render } = column;
        let rawValue;

        if (dataValue) {
          rawValue = objectPath.get(record, dataValue);
        } else if (render) {
          try {
            const dataBindedFields = [];

            const extractDataFields = (obj) => {
              if (!obj) return;

              if (Array.isArray(obj)) {
                obj.forEach((child) => extractDataFields(child));
                return;
              }

              if (obj.props) {
                Object.keys(obj.props).forEach((key) => {
                  if (
                    obj.props[key]?.toString?.().includes("[datafield:") &&
                    key !== "visExField1" &&
                    key !== "visExField2" &&
                    key !== "tooltip"
                  ) {
                    dataBindedFields.push(obj.props[key]);
                  }
                });

                if (Array.isArray(obj.props.children)) {
                  obj.props.children.forEach((child) => extractDataFields(child));
                } else {
                  extractDataFields(obj.props.children);
                }
              }
            };

            const renderedContent = render(null, record, recordIndex);
            extractDataFields(renderedContent);

            if (dataBindedFields.length === 1) {
              const fieldName = dataBindedFields[0].toString().replace("[datafield:", "").replace("]", "");
              rawValue = record[fieldName];
            } else if (
              dataBindedFields.length > 1 &&
              dataBindedFields.every((field) => field === dataBindedFields[0])
            ) {
              const fieldName = dataBindedFields[0].toString().replace("[datafield:", "").replace("]", "");
              rawValue = record[fieldName];
            } else if (dataBindedFields.length > 1) {
              const values = dataBindedFields
                .map((field) => {
                  const fieldName = field.toString().replace("[datafield:", "").replace("]", "");
                  return record[fieldName] !== undefined ? record[fieldName] : "";
                })
                .filter(Boolean);

              let hasVerticalDirection = false;
              try {
                const parentProps = renderedContent?.props;
                if (parentProps?.direction === "vertical") {
                  hasVerticalDirection = true;
                }
                const checkForVerticalDirection = (obj) => {
                  if (!obj) return false;
                  if (obj.props?.direction === "vertical") return true;
                  if (Array.isArray(obj.props?.children)) {
                    return obj.props.children.some((child) => checkForVerticalDirection(child));
                  }
                  if (obj.props?.children) {
                    return checkForVerticalDirection(obj.props.children);
                  }
                  return false;
                };
                if (!hasVerticalDirection) {
                  hasVerticalDirection = checkForVerticalDirection(renderedContent);
                }
              } catch (e) {
                hasVerticalDirection = false;
              }

              rawValue = hasVerticalDirection ? values.join("\n") : values.join(" ");
              if (!hasVerticalDirection) {
                hasMultipleLabels = true;
              }
            } else if (
              typeof renderedContent === "string" ||
              typeof renderedContent === "number" ||
              typeof renderedContent === "boolean"
            ) {
              rawValue = renderedContent;
            } else if (renderedContent?.props?.value !== undefined) {
              rawValue = renderedContent.props.value;
            } else if (
              renderedContent?.props?.children &&
              (typeof renderedContent.props.children === "string" ||
                typeof renderedContent.props.children === "number" ||
                typeof renderedContent.props.children === "boolean")
            ) {
              rawValue = renderedContent.props.children;
            } else if (title && record[title] !== undefined) {
              rawValue = record[title];
            } else if (title && record[title.toLowerCase()] !== undefined) {
              rawValue = record[title.toLowerCase()];
            }
          } catch (e) {
            console.error("Error rendering cell for export:", e);
          }
        } else if (title && record[title] !== undefined) {
          rawValue = record[title];
        } else if (title && record[title.toLowerCase()] !== undefined) {
          rawValue = record[title.toLowerCase()];
        }

        if (rawValue === undefined) {
          if (column.key && record[column.key] !== undefined) {
            rawValue = record[column.key];
          } else if (column.id && record[column.id] !== undefined) {
            rawValue = record[column.id];
          } else if (column.id && record[column.id?.toLowerCase()] !== undefined) {
            rawValue = record[column.id?.toLowerCase()];
          }
        }

        if (rawValue === undefined) {
          rawValue = "";
        }

        const value = footerFormatter ? this.getFormattedValue(rawValue, footerFormatter) : serializeValue(rawValue);

        if (typeof value === "string" && value.includes("\n")) {
          hasMultipleLabels = true;
        }

        rowData[`col${colIndex}`] = value;
      });

      const row = worksheet.addRow(rowData);

      if (hasMultipleLabels) {
        row.height = 28;
      }

      sortedColumns.forEach(({ style, calculatedCellBgColor }: any, colIndex: number) => {
        const cell = row.getCell(colIndex + 1);
        const bgColor = calculatedCellBgColor || style?.backgroundColor;
        if (bgColor) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: colorToARGB(bgColor) }
          };
        }

        const cellValue = cell.value;
        if (typeof cellValue === "string" && cellValue.includes("\n")) {
          cell.alignment = {
            wrapText: true,
            vertical: "top",
            horizontal: "left"
          };
        }
      });
    });

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        const cellLength = cellValue.length;
        if (cellLength > maxLength) {
          maxLength = cellLength;
        }
      });
      column.width = Math.max(10, Math.min(maxLength + 2, 50));
    });

    const leftFixedCount = sortedColumns.filter((col: any) => col.fixed === "left").length;
    if (leftFixedCount > 0) {
      const headerRowCount = Object.keys(columnGroups).length > 0 ? 2 : 1;
      worksheet.views = [
        {
          state: "frozen",
          xSplit: leftFixedCount,
          ySplit: headerRowCount,
          topLeftCell: `${String.fromCharCode(65 + leftFixedCount)}${headerRowCount + 1}`,
          activeCell: `A${headerRowCount + 1}`
        }
      ];
    }

    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const fileName = this.props.exportFileName ? `${this.props.exportFileName}.xlsx` : "export.xlsx";
        saveAs(blob, fileName);
      })
      .catch((error) => {
        console.error("Error saving the file:", error);
      });
  };

  parseColor = (color: string): { r: number; g: number; b: number; a?: number } | null => {
    if (!color) return null;

    color = color.trim();

    if (color.startsWith("#")) {
      const hex = color.substring(1);
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return { r, g, b, a: 1 };
    }

    const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (rgbaMatch) {
      return {
        r: parseInt(rgbaMatch[1]),
        g: parseInt(rgbaMatch[2]),
        b: parseInt(rgbaMatch[3]),
        a: rgbaMatch[4] ? parseFloat(rgbaMatch[4]) : 1
      };
    }

    return null;
  };

  calculateLuminance = (r: number, g: number, b: number): number => {
    const rsRGB = r / 255;
    const gsRGB = g / 255;
    const bsRGB = b / 255;

    const rLinear = rsRGB <= 0.03928 ? rsRGB / 12.92 : ((rsRGB + 0.055) / 1.055) ** 2.4;
    const gLinear = gsRGB <= 0.03928 ? gsRGB / 12.92 : ((gsRGB + 0.055) / 1.055) ** 2.4;
    const bLinear = bsRGB <= 0.03928 ? bsRGB / 12.92 : ((bsRGB + 0.055) / 1.055) ** 2.4;

    return 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;
  };

  getContrastColor = (bgColor: string): string => {
    if (!bgColor || bgColor === "transparent") {
      return "#000000";
    }

    const rgb = this.parseColor(bgColor);
    if (!rgb) {
      return "#000000";
    }

    if (rgb.a !== undefined && rgb.a === 0) {
      return "#000000";
    }

    const luminance = this.calculateLuminance(rgb.r, rgb.g, rgb.b);
    return luminance > 0.5 ? "#000000" : "#ffffff";
  };

  getPopoverStyle = () => {
    const tableBgColor = this.props.style?.backgroundColor || this.props.style?.background;
    const hasTableBgColor = tableBgColor && tableBgColor !== "transparent";
    const contrastColor = hasTableBgColor ? this.getContrastColor(tableBgColor) : "#000000";

    if (!hasTableBgColor) return null;

    return (
      <style>
        {`
          .kuika-export-popover,
          .kuika-column-chooser-popover {
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5) !important;
            border: 1px solid ${contrastColor} !important;
            border-radius: 8px !important;
          }
          .kuika-export-popover .ant-popover-content,
          .kuika-column-chooser-popover .ant-popover-content,
          .kuika-export-popover .kuika-export-column-selector,
          .kuika-column-chooser-popover .kuika_table__column_chooser__checkbox_group {
            background-color: ${tableBgColor} !important;
            border-radius: 8px !important;
          }
          .kuika-export-popover .ant-checkbox-wrapper,
          .kuika-column-chooser-popover .ant-checkbox-wrapper {
            color: ${contrastColor} !important;
          }
          .kuika-export-popover .ant-checkbox-wrapper span,
          .kuika-column-chooser-popover .ant-checkbox-wrapper span {
            color: ${contrastColor} !important;
          }
          .kuika-export-popover .ant-checkbox-inner,
          .kuika-column-chooser-popover .ant-checkbox-inner {
            border-color: ${contrastColor} !important;
            background-color: transparent !important;
          }
          .kuika-export-popover .ant-checkbox-checked .ant-checkbox-inner,
          .kuika-column-chooser-popover .ant-checkbox-checked .ant-checkbox-inner {
            background-color: ${contrastColor} !important;
            border-color: ${contrastColor} !important;
          }
          .kuika-export-popover .ant-checkbox-checked .ant-checkbox-inner::after,
          .kuika-column-chooser-popover .ant-checkbox-checked .ant-checkbox-inner::after {
            border-color: ${tableBgColor} !important;
          }
          .kuika-export-popover .kuika-export-column-item,
          .kuika-column-chooser-popover .draggable-item {
            background-color: transparent !important;
            color: ${contrastColor} !important;
          }
          .kuika-export-popover .kuika-export-column-item:hover,
          .kuika-column-chooser-popover .draggable-item:hover {
            background-color: ${contrastColor}20 !important;
          }
          .kuika-export-popover .kuika-export-column-selector-title,
          .kuika-export-popover .kuika-export-column-label,
          .kuika-column-chooser-popover .kuika-export-column-label {
            color: ${contrastColor} !important;
          }
          .kuika-export-popover .ant-popover-title,
          .kuika-column-chooser-popover .ant-popover-title {
            background-color: ${tableBgColor} !important;
            color: ${contrastColor} !important;
            border-bottom-color: ${contrastColor}40 !important;
          }
          .kuika-export-popover .ant-popover-inner,
          .kuika-column-chooser-popover .ant-popover-inner {
            background-color: ${tableBgColor} !important;
          }
          .kuika-export-popover .ant-popover-arrow::before,
          .kuika-column-chooser-popover .ant-popover-arrow::before {
            background-color: ${tableBgColor} !important;
          }
          .kuika-export-popover .drag-handle,
          .kuika-column-chooser-popover .drag-handle {
            color: ${contrastColor} !important;
          }
        `}
      </style>
    );
  };

  render = (): ReactNode => {
    const isDesignTime = window.kuika?.isDesignTime;
    const defaultEmptyProps = {
      xl: 24 / (this.props as GalleryItemProps).desktopColumnsCount,
      md: 24 / (this.props as GalleryItemProps).tabletColumnsCount,
      sm: 24 / (this.props as GalleryItemProps).phoneColumnsCount,
      xs: 24 / (this.props as GalleryItemProps).phoneColumnsCount,

      style: {
        padding: "5px 5px"
      }
    };
    let defaultTemp = [];

    if (this.props.kuikacomponentname == "GalleryView" && !this.props.children) {
      let a = Array(24).fill(1);
      a.forEach((element, index) => {
        defaultTemp.push(
          <Col {...defaultEmptyProps} key={index}>
            <div className="kuika_emptygalleryviewPlaceholder" />
          </Col>
        );
      });

      return <Row>{defaultTemp}</Row>;
    }
    if (this.props.mode == "carousel" && this.props.kuikacomponentname === "Carousel" && !this.props.children) {
      return <img src={CarouselPlaceholder} style={{ width: "100%" }} />;
    }
    if (this.props.mode == "carousel" && this.props.kuikacomponentname === "HorizontalGrid" && !this.props.children) {
      return <img src={HorizontalGridPlaceholder} style={{ width: "100%" }} />;
    }
    if (this.props.mode == "flex-grid" && !this.props.children && window.kuika.isDesignTime) {
      return <img src={FlexGridPlaceholder} style={{ width: "100%" }} />;
    }
    if (
      this.props.hideTableOnEmpty == true &&
      (this.props.dataSource == undefined || this.props.dataSource.length < 1)
    ) {
      return <></>;
    }

    const filteredList =
      this.props.searchable || this.props.globalSearch || this.state.searchText
        ? this.filterListBySearchText(this.getDataSource(), this.state.searchText)
        : this.getDataSource();
    const language = localStorage.getItem("ml");

    let noDataFoundMessageText = "No data found";
    if (language === "tr_TR") {
      noDataFoundMessageText = "Veri bulunamadı";
    } else if (language === "fr_FR") {
      noDataFoundMessageText = "Aucune donnée trouvée";
    } else if (language === "de_DE") {
      noDataFoundMessageText = "Keine Daten gefunden";
    } else if (language === "es_ES") {
      noDataFoundMessageText = "No se encontraron datos";
    }

    const hasFixedColumns = this.state.columns?.some((col: any) => col.fixed === "left" || col.fixed === "right");
    const hasVisibleFixedColumns = this.state.columns?.some(
      (col: any) =>
        (col.fixed === "left" || col.fixed === "right") &&
        col.visibility !== "hidden" &&
        !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === col.id.toLowerCase())
    );

    return (
      <>
        {this.getPopoverStyle()}
        <div className={`kuika_table__wrapper${this.getClassName()}`}>
          {(this.props.globalSearch || this.props.columnChooser || this.props.export) && (
            <div
              style={{
                display: "flex",
                justifyContent:
                  this.props.style?.textAlign === "-webkit-center"
                    ? "center"
                    : this.props.style?.textAlign === "-webkit-left"
                      ? "flex-start"
                      : "flex-end",
                alignItems: "center",
                paddingBottom: 12,
                backgroundColor: this.props.style?.backgroundColor
              }}
            >
              {this.props.globalSearch && (
                <Input
                  placeholder={language === "tr_TR" ? "Ara..." : "Search..."}
                  style={{
                    width: 240,
                    backgroundColor: "transparent",
                    color: this.getContrastColor(this.props.style?.backgroundColor)
                  }}
                  className="kuika-table-search-input"
                  value={this.state.searchText}
                  onChange={(e) => this.setSearchText(e.target.value)}
                  readOnly={isDesignTime}
                  allowClear
                />
              )}

              {this.props.export && (
                <div className="kuika-table-export-wrapper">
                  <div className="kuika-export-button-group">
                    <Button
                      type="primary"
                      className="kuika-export-button"
                      icon={<DownloadOutlined />}
                      onClick={() => this.onExport()}
                      style={
                        this.props.exportButtonBgColor
                          ? {
                              backgroundColor: this.props.exportButtonBgColor,
                              borderColor: this.props.exportButtonBgColor
                            }
                          : undefined
                      }
                    >
                      {language === "tr_TR" ? "Dışa Aktar" : "Export"}
                    </Button>
                    <Popover
                      content={
                        <div className="kuika-export-column-selector">
                          <div className="kuika-export-column-selector-header">
                            <span className="kuika-export-column-selector-title">
                              {language === "tr_TR" ? "Kolonları Seç" : "Select Columns"}
                            </span>
                          </div>
                          <div className="kuika-export-column-list">
                            {this.state.columns
                              ?.filter(
                                (c: TableColumnProps & CommonProps) => c.visibility !== "hidden" && (c as any).dataValue
                              )
                              .map((c: any, index) => (
                                <div key={c.id} className="kuika-export-column-item">
                                  <Checkbox
                                    checked={!this.state.excludedFromExportList?.includes(c.id)}
                                    onChange={(e) => {
                                      const excludedFromExportList = e.target.checked
                                        ? (this.state.excludedFromExportList || []).filter((id) => id !== c.id)
                                        : [...(this.state.excludedFromExportList || []), c.id];
                                      this.setState({
                                        excludedFromExportList
                                      } as any);
                                    }}
                                  >
                                    <span className="kuika-export-column-label">{c.title}</span>
                                  </Checkbox>
                                </div>
                              ))}
                          </div>
                        </div>
                      }
                      title={language === "tr_TR" ? "Dışa Aktarılacak Kolonlar" : "Columns to Export"}
                      trigger="click"
                      placement="bottomLeft"
                      overlayClassName="kuika-export-popover"
                    >
                      <div
                        className="kuika-export-settings-wrapper"
                        style={
                          this.props.exportButtonBgColor
                            ? {
                                backgroundColor: this.props.exportButtonBgColor,
                                borderColor: this.props.exportButtonBgColor
                              }
                            : undefined
                        }
                      >
                        <SettingOutlined className="kuika-export-settings-icon" />
                      </div>
                    </Popover>
                  </div>
                </div>
              )}

              {this.props.columnChooser && (
                <div style={{ marginLeft: 12 }}>
                  <Popover
                    content={
                      <DragDropContext onDragEnd={this.handleDragEnd}>
                        <Droppable droppableId="columnChooser">
                          {(provided) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              className="kuika_table__column_chooser__checkbox_group"
                            >
                              {this.state.columns
                                ?.filter((c) => c.visibility !== "hidden")
                                .map((c: any, index) => (
                                  <Draggable key={c.id} draggableId={c.id} index={index}>
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className="draggable-item"
                                      >
                                        <MenuOutlined className="drag-handle" />
                                        <Checkbox
                                          checked={!this.state.hiddenColumnList.includes(c.id)}
                                          onChange={(e) => {
                                            if (
                                              this.state.hiddenColumnList.length ===
                                                this.state.columns.filter((c) => c.visibility !== "hidden").length -
                                                  1 &&
                                              !e.target.checked
                                            ) {
                                              return;
                                            }
                                            const hiddenColumnList: any = e.target.checked
                                              ? this.state.hiddenColumnList.filter((id) => id !== c.id)
                                              : [...this.state.hiddenColumnList, c.id];
                                            this.setState({ hiddenColumnList }, () => {
                                              if (this.props.onConfigChange) this.props.onConfigChange();
                                              this.requestSyncColumnWidths();
                                            });
                                          }}
                                        >
                                          {c.title}
                                        </Checkbox>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    }
                    title={
                      language === "tr_TR"
                        ? "Kolon Seçici"
                        : language === "fr_FR"
                          ? "Sélectionneur de colonnes"
                          : "Column Chooser"
                    }
                    trigger="click"
                    placement="bottomLeft"
                    overlayClassName="kuika-column-chooser-popover"
                  >
                    <UnorderedListOutlined
                      style={{
                        pointerEvents: isDesignTime ? "none" : "auto"
                      }}
                    />
                  </Popover>
                </div>
              )}
            </div>
          )}
          <Table
            id={this.props.id}
            style={{ ...this.getTableStyles() }}
            showHeader={this.props.showHeader}
            pagination={this.getPagination()}
            dataSource={filteredList}
            onChange={this.handleTableChange}
            components={{
              table: this.getViewWrapper(),
              header: {
                wrapper: this.state.headerRenderer,
                row: TableHeaderRow,
                cell: TableHeaderCell
              },
              body: {
                wrapper: this.getBodyWrapper(),
                row: this.state.rowRenderer,
                cell: this.getBodyCell()
              }
            }}
            summary={this.renderSummary}
            locale={{
              emptyText: (
                <Empty
                  image={
                    this.props.noDataFoundImage ? (
                      <Image value={this.props.noDataFoundImage} />
                    ) : this.props.mode === "table" || this.props.showNoDataFound ? (
                      <img
                        src={EmptyDataSvg}
                        style={{
                          width: "100%"
                        }}
                      />
                    ) : null
                  }
                  description={
                    this.props.mode === "table" || this.props.showNoDataFound
                      ? this.props.nodatafoundmessage || noDataFoundMessageText
                      : ""
                  }
                />
              )
            }}
            onRow={(rowValue: any, rowIndex?: number) => ({
              ...this.getRowProps(),
              onMouseLeave: (e: any) => {
                this.handleOnRowBlur(e, rowValue, rowIndex);
              },
              onDoubleClick: (e: any) => {
                this.handleRowDoubleClick(e, rowValue, rowIndex);
              },
              onTouchStart: (e: any) => {
                this.timeOutId = setTimeout(() => {
                  this.handleRowDoubleClick(e, rowValue, rowIndex);
                }, 500);
              },
              onTouchEnd: (e: any) => {
                clearTimeout(this.timeOutId);
              },
              onClickCapture: (e: any) => {
                this.handleRowClick(e, rowValue, rowIndex);
              },
              editMode: this.props.editableAlwaysActive ? true : this.state.activeEditableRowIndex == rowIndex,
              style: this.getRowStyle(rowValue, rowIndex),
              hoverFontColor: this.props.rowHoverFontColor,
              transformedOnMobileResolution: this.props.transformedOnMobileResolution,
              hideHeaderOnMobileResolution: this.props.hideHeaderOnMobileResolution,
              hoverBgColor: this.props.rowHoverBgColor,
              selectedBgColor: this.props.selectedRowColor,
              isSelected: this.state.selectedRowKeys?.some(
                (k) =>
                  k?.toString()?.toLowerCase() === rowValue[this.state.actualRowKey || "id"]?.toString()?.toLowerCase()
              ),
              tableClassName: this.getClassName().trim(),
              showTableHeader: this.props.showHeader,
              desktopColumnsCount: (this.props as GalleryItemProps).desktopColumnsCount,
              tabletColumnsCount: (this.props as GalleryItemProps).tabletColumnsCount,
              phoneColumnsCount: (this.props as GalleryItemProps).phoneColumnsCount,
              mode: this.props.mode,
              rowData: rowValue,
              rowIndex,
              isInsertRow: this.isInsertRow(rowValue),
              isInsertRowActive: this.state.activeEditableRowIndex === 0,
              isEditableAlwaysActive: this.props.editableAlwaysActive,
              handleAddRow: () => {
                if (this.props.onRowEditFinished || this.props.onInsertRowFinished) {
                  this.handleOnRowEditFinished();
                }
              },
              handleCancelEditing: () => {
                this.setState({ activeEditableRowIndex: -1 } as any);
              },
              onClick: () => this.resetEditableRow,
              rowComponent: this.getRowComponent(),
              lat: this.getRowLat(rowValue),
              lng: this.getRowLng(rowValue),
              dataLatField: this.props?.dataLatField,
              dataLngField: this.props?.dataLngField,
              waypointLatField: this.props?.waypointLatField,
              waypointLngField: this.props?.waypointLngField,
              marker: {
                lat: this.getRowLat(rowValue),
                lng: this.getRowLng(rowValue)
              },
              rowStyle: this.getRowStyle(rowValue, rowIndex),
              value: this.state.value,
              isDataMarkerSelected: this.state.isDataMarkerSelected,
              onClickDesign: (designClicked: boolean) => {
                if (this.props.onClickDesign) {
                  this.props.onClickDesign(designClicked);
                }
              },
              openDrawer: (content?: any) => {
                if (content !== undefined) {
                  if (this.refreshGoogleMapsBodyWrapper) {
                    this.refreshGoogleMapsBodyWrapper({
                      activeContent: content
                    });
                  }
                }
              },
              designClicked: (this.props.designClicked as any) === "" ? true : this.props.designClicked,
              markerDetailView: this.props.markerDetailView,
              position: this.props.markerDetailPosition,
              height: this.props.markerDetailHeight,
              width: this.props.markerDetailWidth,
              selectedLocationIcon: this.props.selectedLocationIcon,
              selectedLocationColor: this.props.selectedLocationColor
            })}
            onHeaderRow={() => ({
              style: this.state.headerStyle,
              mode: this.props.mode,
              onClick: this.resetEditableRow
            })}
            columns={[
              ...(this.props.showRowNumbers ? [this.getRowNumberColumn()] : []),
              ...(this.state.columnGroups
                ?.map((group, groupIndex) => {
                  let groupLeftPosition = 0;
                  let groupRightPosition = 0;

                  if (group.children.some((c: any) => c.fixed === "left")) {
                    const currentGroupIndex = this.state.columnGroups.findIndex((g) => g.title === group.title);

                    if (currentGroupIndex > 0) {
                      for (let i = 0; i < currentGroupIndex; i++) {
                        const prevGroup = this.state.columnGroups[i];
                        if (prevGroup.children.some((c: any) => c.fixed === "left")) {
                          let groupWidth = 0;
                          prevGroup.children.forEach((child: any, childIndex: number) => {
                            groupWidth += this.cachedColumnWidths.get(`group-${i}-${childIndex}`) || 0;
                          });
                          groupLeftPosition += groupWidth;
                        }
                      }
                    }
                  }

                  if (group.children.some((c: any) => c.fixed === "right")) {
                    const currentGroupIndex = this.state.columnGroups.findIndex((g) => g.title === group.title);
                    const totalGroups = this.state.columnGroups.length;

                    if (currentGroupIndex < totalGroups - 1) {
                      for (let i = currentGroupIndex + 1; i < totalGroups; i++) {
                        const nextGroup = this.state.columnGroups[i];
                        if (nextGroup.children.some((c: any) => c.fixed === "right")) {
                          let groupWidth = 0;
                          nextGroup.children.forEach((child: any, childIndex: number) => {
                            groupWidth += this.cachedColumnWidths.get(`group-${i}-${childIndex}`) || 0;
                          });
                          groupRightPosition += groupWidth;
                        }
                      }
                    }
                  }

                  const visibleChildren = group.children.filter(
                    (child) => !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === child.id.toLowerCase())
                  );

                  if (visibleChildren.length === 0) {
                    return null;
                  }

                  return {
                    title: group.title,
                    children: visibleChildren?.map((child, childIndex) => {
                      (child as any).sortOrder =
                        this.state.sorterOptions?.field === (child as any).dataValue &&
                        this.state.sorterOptions?.columnId === child.id
                          ? this.state.sorterOptions?.order
                          : undefined;
                      return this.createColumnConfig(child, `group-${groupIndex}-${childIndex}`, true);
                    }),
                    style: {
                      ...group.style,
                      borderTop: `1px solid ${this.state.headerStyle.borderColor || "rgb(218, 218, 218)"}`,
                      borderBottom: `1px solid ${this.state.headerStyle.borderColor || "rgb(218, 218, 218)"}`,
                      borderRight: `1px solid ${this.state.headerStyle.borderColor || "rgb(218, 218, 218)"}`,
                      borderLeft: `1px solid ${this.state.headerStyle.borderColor || "rgb(218, 218, 218)"}`,
                      backgroundColor: group.groupBackgroundColor || group.style?.backgroundColor,
                      color: group.groupFontColor || group.style?.color,
                      fontSize: group.groupFontSize ? `${group.groupFontSize}px` : undefined,
                      fontWeight: group.groupFontWeight ? BaseTable.mapFontWeight(group.groupFontWeight) : undefined
                    },
                    hasGrouping: true,
                    fixed: group.children.some((c: any) => c.fixed === "left")
                      ? "left"
                      : group.children.some((c: any) => c.fixed === "right")
                        ? "right"
                        : undefined,
                    left: groupLeftPosition > 0 ? groupLeftPosition : undefined,
                    right: groupRightPosition > 0 ? groupRightPosition : undefined,
                    onHeaderCell: () => ({
                      style: {
                        ...group.style,
                        borderTop: `1px solid ${this.state.headerStyle.borderColor || "rgb(218, 218, 218)"}`,
                        borderBottom: `1px solid ${this.state.headerStyle.borderColor || "rgb(218, 218, 218)"}`,
                        borderRight: `1px solid ${this.state.headerStyle.borderColor || "rgb(218, 218, 218)"}`,
                        borderLeft: `1px solid ${this.state.headerStyle.borderColor || "rgb(218, 218, 218)"}`,
                        backgroundColor: group.groupBackgroundColor || group.style?.backgroundColor,
                        color: group.groupFontColor || group.style?.color,
                        fontSize: group.groupFontSize ? `${group.groupFontSize}px` : undefined,
                        fontWeight: group.groupFontWeight ? BaseTable.mapFontWeight(group.groupFontWeight) : undefined
                      },
                      hasGrouping: true,
                      isGroupCell: true,
                      groupBackgroundColor: group.groupBackgroundColor,
                      groupFontColor: group.groupFontColor,
                      groupFontSize: group.groupFontSize,
                      groupFontWeight: group.groupFontWeight,
                      fixed: group.children.some((c: any) => c.fixed === "left")
                        ? "left"
                        : group.children.some((c: any) => c.fixed === "right")
                          ? "right"
                          : undefined,
                      left: groupLeftPosition > 0 ? groupLeftPosition : undefined,
                      right: groupRightPosition > 0 ? groupRightPosition : undefined
                    })
                  };
                })
                .filter(Boolean) || []),
              ...this.state.columns
                ?.filter(
                  (c: any) =>
                    c.visibility !== "hidden" &&
                    !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === c.id.toLowerCase()) &&
                    !c.isGroup
                )
                .map((column: any, columnIndex: number) => {
                  const { columns } = this.state;
                  column.sortOrder =
                    this.state.sorterOptions?.field === column.dataValue &&
                    this.state.sorterOptions?.columnId === column.id
                      ? this.state.sorterOptions?.order
                      : undefined;
                  if (this.props.tableWidthMode === "scroll" || this.props.tableWidthMode === "horizontal scroll") {
                    column.width = column.style.width ?? "min-content";
                    column.style.width = column.width;
                    column.style.minWidth = column.style.width;
                  }
                  if (this.state.columnWidths && this.state.columnWidths[columnIndex] !== undefined) {
                    column.width = this.state.columnWidths[columnIndex];
                    column.style.width = column.width;
                  }
                  return this.createColumnConfig(column, columnIndex, false);
                })
            ]}
            loading={this.props.loading}
            size={this.props.size}
            bordered={false}
            scroll={
              this.props.tableWidthMode === "scroll" ||
              this.props.tableWidthMode === "horizontal scroll" ||
              this.state.columns?.some(
                (col) =>
                  ((col as any).fixed === "left" || (col as any).fixed === "right") &&
                  col.visibility !== "hidden" &&
                  !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === col.id.toLowerCase())
              )
                ? {
                    x: "max-content",
                    y:
                      this.props.fixedHeader && hasFixedColumns
                        ? (() => {
                            const containerHeight = this.props.style?.height || this.props.style?.maxHeight;
                            if (containerHeight) {
                              const heightValue =
                                typeof containerHeight === "string"
                                  ? parseInt(containerHeight.replace(/px|%|em|rem/g, ""), 10)
                                  : containerHeight;
                              return Math.max(200, heightValue - (this.props.pagination ? 80 : 40));
                            }
                            return 400;
                          })()
                        : undefined
                  }
                : this.props.fixedHeader && hasFixedColumns
                  ? {
                      y: (() => {
                        const containerHeight = this.props.style?.height || this.props.style?.maxHeight;
                        if (containerHeight) {
                          const heightValue =
                            typeof containerHeight === "string"
                              ? parseInt(containerHeight.replace(/px|%|em|rem/g, ""), 10)
                              : containerHeight;
                          return Math.max(200, heightValue - (this.props.pagination ? 80 : 40));
                        }
                        return 400;
                      })()
                    }
                  : undefined
            }
            rowKey={this.state.actualRowKey || "id"}
            rowSelection={
              this.props.multiSelect
                ? {
                    type: "checkbox",
                    selectedRowKeys: this.getSelectedRowKeysForAntd(),
                    onSelect: (record, selected, selectedRows) => {
                      const { selectedRowKeys } = this.state;
                      const actualRowKey = this.state.actualRowKey || "id";
                      const recordValue = record[actualRowKey];

                      const updatedRowKeys = selected
                        ? [...selectedRowKeys, recordValue]
                        : selectedRowKeys.filter(
                            (key) => key?.toString()?.toLowerCase() !== recordValue?.toString()?.toLowerCase()
                          );

                      const updatedRowKeysString = updatedRowKeys.length > 0 ? updatedRowKeys.join(",") : "";

                      this.setState(
                        {
                          selectedRowKeys: updatedRowKeys,
                          selectedRowKeysString: updatedRowKeysString
                        },
                        () => {
                          this.props.onSelectedValuesChange?.();
                        }
                      );
                    },
                    onSelectAll: (selected, selectedRows, changeRows) => {
                      const { multiSelectScope, dataSource, onSelectedValuesChange } = this.props;
                      const actualRowKey = this.state.actualRowKey || "id";

                      const getRecordValue = (row) => {
                        return row[actualRowKey];
                      };

                      const updateState = (keys, keysString) => {
                        this.setState(
                          {
                            selectedRowKeys: keys,
                            selectedRowKeysString: keysString
                          },
                          () => {
                            if (onSelectedValuesChange) {
                              onSelectedValuesChange();
                            }
                          }
                        );
                      };

                      const generateKeysString = (rows) =>
                        rows.length > 0 ? rows.map((row) => getRecordValue(row)).join(",") : "";

                      if (multiSelectScope === "all") {
                        const allRowKeys = dataSource.map((row) => getRecordValue(row));
                        const allRowKeysString = generateKeysString(dataSource);

                        if (selectedRows.length - 1 !== dataSource.length && selected) {
                          updateState(allRowKeys, allRowKeysString);
                        } else {
                          updateState([], "");
                        }
                      } else {
                        const selectedRowKeys = selectedRows
                          ?.filter((row) => row !== undefined)
                          ?.map((row) => getRecordValue(row));
                        const selectedRowKeysString = generateKeysString(selectedRows);

                        updateState(selectedRowKeys, selectedRowKeysString);
                      }
                    }
                  }
                : undefined
            }
          />

          <input type="hidden" id={this.state.selectedIndexGuid} className="selected-index-guid"></input>
          <input type="hidden" id={this.state.selectedColumnIndexGuid} className="selected-column-index-guid"></input>
          <input type="hidden" id={this.state.selectedRowDataGuid} className="selected-row-data-guid"></input>
        </div>
      </>
    );
  };

  createColumnConfig = (column: any, columnIndex: any, isGroup: boolean) => {
    const { columns } = this.state;
    const hasGrouping = this.state.columnGroups?.length > 0 || columns?.some((col) => col.group);

    let leftPosition = 0;
    let rightPosition = 0;

    const isHidden = this.state.hiddenColumnList?.some((id) => id.toLowerCase() === column.id.toLowerCase());
    const fixed = isHidden ? undefined : column.fixed;

    if (column.fixed === "left" && !isHidden) {
      const visibleColumns = this.state.columns
        ?.filter((c: any) => c.visibility !== "hidden")
        ?.filter((c: any) => !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === c.id.toLowerCase()));

      const visibleGroupColumns =
        this.state.columnGroups
          ?.map((group) =>
            group.children.filter((c: any) => c.visibility !== "hidden" && !this.state.hiddenColumnList?.includes(c.id))
          )
          .flat() || [];

      const allVisibleColumns = [...visibleColumns, ...visibleGroupColumns].filter(
        (c: any, index, self) => index === self.findIndex((t: any) => t.id === c.id)
      );

      const leftFixedColumns = allVisibleColumns
        .filter((col: any) => col.fixed === "left")
        .sort((a: any, b: any) => {
          const aIndex = this.state.columnOrder.indexOf(a.id);
          const bIndex = this.state.columnOrder.indexOf(b.id);
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          return 0;
        });

      for (let i = 0; i < leftFixedColumns.length; i++) {
        const col: any = leftFixedColumns[i];
        if (col.id === column.id) break;

        let colWidth = 0;

        const groupIndex = this.state.columnGroups?.findIndex((group) =>
          group.children.some((child: any) => child.id === col.id)
        );

        if (groupIndex !== -1 && groupIndex !== undefined) {
          const childIndex = this.state.columnGroups[groupIndex].children.findIndex(
            (child: any) => child.id === col.id
          );
          colWidth = this.cachedColumnWidths.get(`group-${groupIndex}-${childIndex}`) || 0;
        } else {
          const regularIndex = visibleColumns.findIndex((c: any) => c.id === col.id);
          if (regularIndex !== -1) {
            colWidth = this.cachedColumnWidths.get(String(regularIndex)) || 0;
          }
        }
        if (!colWidth && col.width) {
          colWidth = typeof col.width === "number" ? col.width : parseInt(col.width, 10) || 100;
        } else if (!colWidth && col.style && col.style.width) {
          colWidth = typeof col.style.width === "number" ? col.style.width : parseInt(col.style.width, 10) || 100;
        }

        leftPosition += colWidth;
      }
    }

    if (column.fixed === "right" && !isGroup && !isHidden) {
      const visibleColumns = this.state.columns
        ?.filter((c: any) => c.visibility !== "hidden")
        ?.filter((c: any) => !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === c.id.toLowerCase()));

      const rightFixedColumns = visibleColumns?.filter((col: any) => col.fixed === "right") || [];

      const rightFixedIndex = rightFixedColumns.findIndex((col: any) => col.id === column.id);

      if (rightFixedIndex > 0) {
        for (let i = 0; i < rightFixedIndex; i++) {
          const rightCol: any = rightFixedColumns[i];
          if (this.state.hiddenColumnList?.some((id) => id.toLowerCase() === rightCol.id.toLowerCase())) {
            continue;
          }
          const rightColIndex = visibleColumns.findIndex((col: any) => col.id === rightCol.id);

          let colWidth = this.cachedColumnWidths.get(String(rightColIndex)) || 0;
          if (!colWidth && rightCol.width) {
            colWidth = typeof rightCol.width === "number" ? rightCol.width : parseInt(rightCol.width, 10) || 100;
          } else if (!colWidth && rightCol.style && rightCol.style.width) {
            colWidth =
              typeof rightCol.style.width === "number"
                ? rightCol.style.width
                : parseInt(rightCol.style.width, 10) || 100;
          }

          rightPosition += colWidth;
        }
      }
    }

    return {
      ...column,
      fixed,
      onCell: (rowData: any, rowIndex?: number): any => ({
        onCellClick: (_e: any, _columnIndex: number, _rowData: any, _rowIndex: number) => {
          this.handleCellClick(_e, _columnIndex || columnIndex, _rowData || rowData, _rowIndex || rowIndex);
        },
        onCellBlur: (_e: any) => {
          this.handleCellBlur(_e, rowIndex, columnIndex);
        },
        style: column.style,
        calculatedCellBgColor: column.calculatedCellBgColor,
        calculatedCellFontColor: column.calculatedCellFontColor,
        alwaysVisibleOnMobileResolution: column.alwaysVisibleOnMobileResolution,
        rowIndex,
        rowData,
        columnIndex,
        title: column.title,
        columns: columns?.filter((x: any) => x.visible === true),
        mode: this.props.mode,
        isEditable: column.isEditableColumn,
        isEditMode:
          (column.isEditableColumn && this.state.activeEditableRowIndex == rowIndex) ||
          (this.props.editableAlwaysActive && column.isEditableColumn),
        editableAlwaysActive: this.props.editableAlwaysActive,
        dataValue: column.dataValue,
        dataType: column.dataType ?? ValueType.String,
        setResizingColumnIndex: this.setResizingColumnIndex,
        resizeListener: this.resizeListener,
        index: columnIndex,
        resizableColumns: this.props.resizableColumns,
        tableId: this.props.id,
        fixed: fixed || undefined,
        left: leftPosition,
        right: rightPosition
      }),
      onHeaderCell: (): any => ({
        style: this.state.headerStyle,
        columnStyle: column.style,
        headerStyle: this.state.headerStyle,
        title: column.title,
        secondTitle: column.secondTitle,
        mode: this.props.mode,
        textDirection: this.props.children[0]?.props?.textDirection,
        columnSearchText: this.state.columnSearchTexts,
        setColumnSearchText: this.setColumnSearchTexts,
        onHeaderSearchBlur: this.onHeaderSearchBlur,
        searchable: this.props.searchable,
        type: column.dataType ?? ValueType.String,
        dataValue: column.dataValue,
        index: columnIndex,
        resizeListener: this.resizeListener,
        setResizingColumnIndex: this.setResizingColumnIndex,
        resizableColumns: this.props.resizableColumns,
        hidden: this.state.hiddenColumnList.includes(column.id),
        isSearchHidden: column.hideSearch,
        isFilteringHidden: column.hideFiltering,
        isSortingHidden: column.hideSorting,
        tableFiltering: this.props.filtering,
        tableSorting: this.props.sorter,
        hasGrouping,
        shouldSearchOnChange: this.props.shouldSearchOnChange,
        searchDelay: this.props.searchDelay,
        isGroupCell: isGroup,
        titleBgColor: column.titleBgColor,
        placeholder: column.placeholder,
        fixed: fixed || undefined,
        left: leftPosition,
        right: rightPosition,
        filteredValue: column.filteredValue,
        groupBackgroundColor: undefined,
        groupFontColor: undefined,
        groupFontSize: undefined,
        groupFontWeight: undefined,
        isFirstColumn: columnIndex === 0,
        isLastColumn: columnIndex === columns.length - 1,
        dateSearchFormat: column.dateSearchFormat,
        tableBgColor: this.props.style?.backgroundColor,
        getContrastTextColor: this.getContrastColor
      })
    };
  };

  private getRowNumberColumn = () => {
    const { current = 1, pageSize = 10 } = this.state;
    const paginationEnabled = this.props.pagination === true;
    const offset = paginationEnabled ? (current - 1) * pageSize : 0;

    return {
      title: "#",
      dataIndex: "__kuika_row_number__",
      key: "__kuika_row_number__",
      width: 50,
      sorter: false,
      render: (_: any, _record: any, rowIndex: number) => offset + rowIndex + 1,
      onHeaderCell: (): any => ({
        style: { ...this.state.headerStyle, textAlign: "center", padding: "8px 4px" },
        isRowNumberColumn: true
      }),
      onCell: (): any => ({
        style: { textAlign: "center", padding: "8px 4px" },
        isRowNumberColumn: true
      })
    };
  };

  updateFixedGroupColumnPositions = (cellWidths: number[]) => {
    try {
      const tableWrapper = document.getElementById(this.props.id || `kuika_${(this.props as any)?.kuikaid}`);
      if (!tableWrapper || !this.state.columnGroups?.length) return;

      const groupHeaders = tableWrapper.querySelectorAll(".ant-table-thead th[colspan]");

      this.state.columnGroups.forEach((group, groupIndex) => {
        const isFixedLeft = group.children.some((child: any) => child.fixed === "left");
        const isFixedRight = group.children.some((child: any) => child.fixed === "right");

        if (isFixedLeft || isFixedRight) {
          const groupHeader = Array.from(groupHeaders).find(
            (header: HTMLElement) => header.textContent?.trim() === group.title
          ) as HTMLElement;

          if (groupHeader) {
            if (isFixedLeft) {
              let groupLeftPosition = 0;
              for (let i = 0; i < groupIndex; i++) {
                const prevGroup = this.state.columnGroups[i];
                if (prevGroup.children.some((c: any) => c.fixed === "left")) {
                  const prevGroupWidth = prevGroup.children.reduce((sum, child: any, childIndex) => {
                    const cellIndex = this.findCellIndexForColumn(child.id);
                    return sum + (cellWidths[cellIndex] || 0);
                  }, 0);
                  groupLeftPosition += prevGroupWidth;
                }
              }
              groupHeader.style.left = `${groupLeftPosition}px`;
            }

            if (isFixedRight) {
              let groupRightPosition = 0;
              for (let i = groupIndex + 1; i < this.state.columnGroups.length; i++) {
                const nextGroup = this.state.columnGroups[i];
                if (nextGroup.children.some((c: any) => c.fixed === "right")) {
                  const nextGroupWidth = nextGroup.children.reduce((sum, child: any, childIndex) => {
                    const cellIndex = this.findCellIndexForColumn(child.id);
                    return sum + (cellWidths[cellIndex] || 0);
                  }, 0);
                  groupRightPosition += nextGroupWidth;
                }
              }
              groupHeader.style.right = `${groupRightPosition}px`;
            }
          }
        }
      });
    } catch (error) {
      console.warn("Error updating fixed group column positions:", error);
    }
  };

  findCellIndexForColumn = (columnId: string): number => {
    const visibleColumns = this.state.columns
      ?.filter((c: any) => c.visibility !== "hidden")
      ?.filter((c: any) => !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === c.id.toLowerCase()));

    return visibleColumns?.findIndex((col: any) => col.id === columnId) || 0;
  };

  updateFixedColumnPositions = (
    headerCells: HTMLTableCellElement[],
    bodyCells: HTMLTableCellElement[],
    cellWidths: number[]
  ) => {
    try {
      const tableWrapper = document.getElementById(this.props.id || `kuika_${(this.props as any)?.kuikaid}`);
      if (!tableWrapper) return;

      let leftPosition = 0;
      headerCells.forEach((headerCell, index) => {
        const isFixedLeft = headerCell.className.includes("ant-table-cell-fix-left");
        const bodyCell = bodyCells[index];

        if (isFixedLeft) {
          headerCell.style.left = `${leftPosition}px`;

          if (bodyCell) {
            bodyCell.style.left = `${leftPosition}px`;
          }

          const columnIndex = headerCell.getAttribute("columnindex");
          if (columnIndex) {
            const allBodyCells = tableWrapper.querySelectorAll(`td[columnindex="${columnIndex}"]`);
            allBodyCells.forEach((cell: HTMLElement) => {
              if (cell.className.includes("ant-table-cell-fix-left")) {
                cell.style.left = `${leftPosition}px`;
              }
            });
          }

          leftPosition += cellWidths[index] || 0;
        }
      });

      let rightPosition = 0;
      for (let i = headerCells.length - 1; i >= 0; i--) {
        const headerCell = headerCells[i];
        const isFixedRight = headerCell.className.includes("ant-table-cell-fix-right");
        const bodyCell = bodyCells[i];

        if (isFixedRight) {
          headerCell.style.right = `${rightPosition}px`;

          if (bodyCell) {
            bodyCell.style.right = `${rightPosition}px`;
          }

          const columnIndex = headerCell.getAttribute("columnindex");
          if (columnIndex) {
            const allBodyCells = tableWrapper.querySelectorAll(`td[columnindex="${columnIndex}"]`);
            allBodyCells.forEach((cell: HTMLElement) => {
              if (cell.className.includes("ant-table-cell-fix-right")) {
                cell.style.right = `${rightPosition}px`;
              }
            });
          }

          rightPosition += cellWidths[i] || 0;
        }
      }

      this.updateFixedGroupColumnPositions(cellWidths);
    } catch (error) {
      console.warn("Error updating fixed column positions:", error);
    }
  };

  requestSyncColumnWidths = () => {
    if (this.syncWidthsTimerId !== undefined) {
      clearTimeout(this.syncWidthsTimerId);
    }
    this.syncWidthsTimerId = setTimeout(() => {
      this.syncWidthsTimerId = undefined;
      this.syncColumnWidths();
    }, 100);
  };

  private static sortCellsByFixedPosition(
    cells: HTMLTableCellElement[],
    indexMap: Map<HTMLTableCellElement, number>
  ): HTMLTableCellElement[] {
    return cells.sort((a, b) => {
      const aIsFixedLeft = a.className.includes("ant-table-cell-fix-left");
      const bIsFixedLeft = b.className.includes("ant-table-cell-fix-left");
      const aIsFixedRight = a.className.includes("ant-table-cell-fix-right");
      const bIsFixedRight = b.className.includes("ant-table-cell-fix-right");

      if (aIsFixedLeft && !bIsFixedLeft) return -1;
      if (!aIsFixedLeft && bIsFixedLeft) return 1;
      if (aIsFixedRight && !bIsFixedRight) return 1;
      if (!aIsFixedRight && bIsFixedRight) return -1;

      const aColumnIndex = a.getAttribute("columnindex") || "";
      const bColumnIndex = b.getAttribute("columnindex") || "";
      const aIsGroup = aColumnIndex.startsWith("group-");
      const bIsGroup = bColumnIndex.startsWith("group-");

      if (
        (aIsFixedLeft && bIsFixedLeft) ||
        (aIsFixedRight && bIsFixedRight) ||
        (!aIsFixedLeft && !aIsFixedRight && !bIsFixedLeft && !bIsFixedRight)
      ) {
        if (!aIsGroup && bIsGroup) return -1;
        if (aIsGroup && !bIsGroup) return 1;
      }

      return (indexMap.get(a) ?? 0) - (indexMap.get(b) ?? 0);
    });
  }

  private static filterScrollbarCells(cells: HTMLTableCellElement[]): HTMLTableCellElement[] {
    return cells.filter((cell) => {
      const cn = cell.className || "";
      return (
        !cn.includes("ant-table-cell-scrollbar") && !cn.includes("scrollbar") && !cn.includes("ant-table-placeholder")
      );
    });
  }

  syncColumnWidths = () => {
    const hasVisibleFixedColumns = this.state.columns?.some(
      (col: any) =>
        (col.fixed === "left" || col.fixed === "right") &&
        col.visibility !== "hidden" &&
        !this.state.hiddenColumnList?.some((id) => id.toLowerCase() === col.id.toLowerCase())
    );

    if (!this.props.fixedHeader || !hasVisibleFixedColumns) {
      return;
    }

    const tableWrapper = document.getElementById(this.props.id || `kuika_${(this.props as any)?.kuikaid}`);
    if (!tableWrapper) return;

    const headerTable = tableWrapper.querySelector(".ant-table-header table") as HTMLTableElement;
    const bodyTable = tableWrapper.querySelector(".ant-table-body table") as HTMLTableElement;

    if (!headerTable || !bodyTable) return;

    try {
      const allHeaderCells = Array.from(headerTable.querySelectorAll("thead tr th")) as HTMLTableCellElement[];
      const headerIndexMap = new Map<HTMLTableCellElement, number>();
      allHeaderCells.forEach((cell, i) => headerIndexMap.set(cell, i));

      const headerCells = BaseTable.sortCellsByFixedPosition(
        allHeaderCells.filter((cell) => {
          const colspan = parseInt(cell.getAttribute("colspan") || "1");
          const mode = cell.getAttribute("mode") === "table";
          if (!mode || colspan > 1) return false;
          const cn = cell.className || "";
          return (
            !cn.includes("ant-table-cell-scrollbar") &&
            !cn.includes("scrollbar") &&
            !cn.includes("ant-table-placeholder")
          );
        }),
        headerIndexMap
      );

      const bodyRows = Array.from(bodyTable.querySelectorAll("tbody tr")) as HTMLTableRowElement[];

      if (headerCells.length === 0 || bodyRows.length === 0) return;

      // Prefer the second row (the first can be a measurement/editable ghost row),
      // but fall back to the first so a single-row table still syncs instead of
      // throwing and leaving header/body widths unaligned.
      const firstBodyRow = bodyRows[1] ?? bodyRows[0];
      const allBodyCells = Array.from(firstBodyRow.querySelectorAll("td")) as HTMLTableCellElement[];
      const bodyIndexMap = new Map<HTMLTableCellElement, number>();
      allBodyCells.forEach((cell, i) => bodyIndexMap.set(cell, i));

      const bodyCells = BaseTable.sortCellsByFixedPosition(BaseTable.filterScrollbarCells(allBodyCells), bodyIndexMap);

      if (headerCells.length !== bodyCells.length) return;

      headerTable.style.tableLayout = "auto";
      bodyTable.style.tableLayout = "auto";

      // Batch all reads
      const cellWidths: number[] = [];
      bodyCells.forEach((cell, index) => {
        const width = cell.getBoundingClientRect().width;
        cellWidths[index] = Math.max(width, 90);
      });

      // Build new column index → width mapping and check for changes
      const newWidths = new Map<string, number>();
      bodyCells.forEach((cell, index) => {
        const colIdx = cell.getAttribute("columnindex");
        if (colIdx && cellWidths[index]) {
          newWidths.set(colIdx, cellWidths[index]);
        }
      });

      if (
        newWidths.size === this.cachedColumnWidths.size &&
        ![...newWidths].some(([k, v]) => this.cachedColumnWidths.get(k) !== v)
      ) {
        headerTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        return;
      }

      this.cachedColumnWidths = newWidths;

      // Batch all writes
      headerCells.forEach((headerCell, index) => {
        if (cellWidths[index]) {
          headerCell.style.width = `${cellWidths[index]}px`;
          headerCell.style.minWidth = `${cellWidths[index]}px`;
          headerCell.style.maxWidth = `${cellWidths[index]}px`;
        }
      });

      bodyCells.forEach((bodyCell, index) => {
        if (cellWidths[index]) {
          bodyCell.style.width = `${cellWidths[index]}px`;
          bodyCell.style.minWidth = `${cellWidths[index]}px`;
          bodyCell.style.maxWidth = `${cellWidths[index]}px`;
        }
      });

      bodyRows.forEach((row, rowIndex) => {
        if (rowIndex === 1) return;

        const allCells = Array.from(row.querySelectorAll("td")) as HTMLTableCellElement[];
        const rowIndexMap = new Map<HTMLTableCellElement, number>();
        allCells.forEach((cell, i) => rowIndexMap.set(cell, i));

        const cells = BaseTable.sortCellsByFixedPosition(BaseTable.filterScrollbarCells(allCells), rowIndexMap);

        cells.forEach((cell, cellIndex) => {
          if (cellWidths[cellIndex]) {
            cell.style.width = `${cellWidths[cellIndex]}px`;
            cell.style.minWidth = `${cellWidths[cellIndex]}px`;
            cell.style.maxWidth = `${cellWidths[cellIndex]}px`;
          }
        });
      });

      const headerColgroup = headerTable.querySelector("colgroup");
      const bodyColgroup = bodyTable.querySelector("colgroup");

      if (headerColgroup && bodyColgroup) {
        const headerCols = Array.from(headerColgroup.querySelectorAll("col"));
        const bodyCols = Array.from(bodyColgroup.querySelectorAll("col"));

        // colgroup <col>s are in visual column order (leaf-only). Use body row tds in
        // DOM order — which is also visual column order — to read each column's natural
        // width. Indexing into `allHeaderCells` was wrong when grouped headers existed,
        // because allHeaderCells interleaves the group-header row and the leaf-header
        // row, so headerCols[i] did not correspond to allHeaderCells[i]. That caused
        // each leaf column's colgroup width to be taken from the wrong column,
        // shifting parent group headers (with colspan) relative to their children.
        const visualBodyCells = BaseTable.filterScrollbarCells(allBodyCells);
        const colCount = Math.min(headerCols.length, bodyCols.length, visualBodyCells.length);
        for (let i = 0; i < colCount; i++) {
          const visualCell = visualBodyCells[i];
          const width = Math.max(visualCell.getBoundingClientRect().width, 90);
          headerCols[i].style.width = `${width}px`;
          bodyCols[i].style.width = `${width}px`;
        }
      }

      const allBodyCellsFromAllRows: HTMLTableCellElement[] = [];
      bodyRows.forEach((row) => {
        const rowCells = Array.from(row.querySelectorAll("td")) as HTMLTableCellElement[];
        const filteredRowCells = rowCells.filter((cell) => {
          const className = cell.className || "";
          if (
            className.includes("ant-table-cell-scrollbar") ||
            className.includes("scrollbar") ||
            className.includes("ant-table-placeholder")
          ) {
            return false;
          }
          return true;
        });
        this.updateFixedColumnPositions(headerCells, filteredRowCells, cellWidths);
      });

      headerTable.style.tableLayout = "fixed";
      bodyTable.style.tableLayout = "fixed";

      const totalWidth = cellWidths.reduce((sum, width) => sum + width, 0);
      if (totalWidth > 0) {
        headerTable.style.minWidth = `${totalWidth}px`;
        bodyTable.style.minWidth = `${totalWidth}px`;
      }
    } catch (error) {
      console.warn("Error syncing column widths:", error);
    }
  };
}
